import * as React from 'react'

const SvgNotAvailableImage = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 900 544"
    width="100%"
    height="100%"
    preserveAspectRatio="none"
    {...props}
  >
    <path fill="#F7F7F7" d="M0 0h900v544H0V0Z" />
    <path
      fill="#F1F1F1"
      d="M501 41c3.766 6.994 6.357 14.272 8.95 21.766l1.387 3.972c.964 2.76 1.924 5.52 2.882 8.28 1.226 3.535 2.458 7.067 3.692 10.599 1.182 3.382 2.36 6.765 3.538 10.149l.678 1.944a400223227.407 400223227.407 0 0 0 2.982 8.585A75.25 75.25 0 0 1 527 113l1.999-.013c6.845-.045 13.69-.075 20.535-.097 2.557-.01 5.114-.024 7.671-.04 3.669-.025 7.337-.036 11.006-.045l3.482-.032h3.215l2.84-.014C580 113 580 113 582 115c.195 2.594.265 5.08.247 7.675l.008 2.428c.005 2.7-.003 5.4-.012 8.1l.006 5.79c.005 5.251-.003 10.503-.013 15.755-.009 5.485-.007 10.97-.007 16.454 0 9.212-.01 18.423-.023 27.634-.016 10.666-.021 21.331-.02 31.997 0 10.24-.005 20.481-.013 30.722-.004 4.368-.006 8.735-.006 13.102-.001 5.137-.007 10.275-.017 15.412-.003 1.89-.004 3.782-.004 5.673 0 2.57-.005 5.14-.012 7.71l.004 2.298c-.024 5.136-.024 5.136-1.138 6.25l-1 8h-20v20h20v19l20 1v-20h20v19l5 1c5.625 3.1 8.248 6.758 11.25 12.313C637 375 637 375 637 384h-29c2.683 8.606 2.683 8.606 6 10 3.458.417 3.458.417 7 0l1.336-2.035L624 390c2.918-.172 2.918-.172 6.188.25l3.292.39c.832.12 1.663.238 2.52.36-1.042 4.48-2.517 7.127-6.203 9.965-3.12 1.797-6.275 2.367-9.797 3.035v16h20v20h20v20h20v20h20v20h20v40h-20v-20h-20v20h-20v-20h-20v20h-20v-20h-20v20h-20v-20h-20v-20h6v-57h12v17h2v-20h-20v-20h-20v-17h-11l-1-4c-.534.36-1.067.722-1.617 1.094-5.802 3.613-10.554 5.16-17.383 3.906-4.413-2.166-7.09-4.439-9-9-.4-4.477-.323-8.094 2-12 4.701-3.722 9.057-5.047 14.875-6.25l2.375-.523c1.914-.42 3.832-.825 5.75-1.227.043-1.666.04-3.334 0-5-1.034-1.26-1.034-1.26-3.285-1.098l-2.778.036-2.785.027L514 369l-2 4c-3.47-.458-6.674-.891-10-2 .285-3.323.957-4.944 3-7.625 4.431-3.508 9.32-5.375 15-5.375v-18h-20v-20h-20v20h-20v20l5.375-.5c16.972-1.36 16.972-1.36 22.625 2.5 2.726 2.622 3 4.004 3.34 7.85 0 1.545-.017 3.09-.047 4.634l-.013 2.472a944.441 944.441 0 0 1-.092 7.794 3367.49 3367.49 0 0 0-.042 5.293c-.033 4.32-.084 8.638-.146 12.957h-11l-.076-2.906c-.094-3.552-.194-7.104-.296-10.656-.044-1.538-.085-3.077-.125-4.615-.058-2.21-.122-4.419-.187-6.628l-.05-2.09c-.074-3.676-.074-3.676-1.266-7.105l-3.813-.25-2.144-.14c-2.166.216-2.166.216-3.639 1.98-1.876 3.22-1.837 5.647-1.916 9.363l-.054 2a643.375 643.375 0 0 0-.122 6.297c-.033 1.427-.067 2.854-.103 4.281-.085 3.49-.152 6.98-.209 10.469h-12v-3h-14v20h20v20h20v19c4.667-.157 4.667-.157 9.333-.36 5.082-.086 7.8 1.154 11.667 4.36 2.558 2.51 2.965 3.618 3.293 7.234l-.106 3.516-.082 3.547L504 480h10v-20h-14v-20h20v3h6l1 20 6-4c5.373-1.027 11.166-1.065 15.938 1.875 5.04 4.436 7.614 9.946 8.542 16.535.319 7.907-.814 14.105-5.48 20.59-2.625 2.5-2.625 2.5-5 4l-3 2h-4v16h-20v20h-20v-20h-20v20h-20v-20h-20v-20h-6v3h-12v-43h-2v-20h-20v20l6 1c3.552 3.256 4.784 4.807 5.644 9.555l.028 3.89.039 2.098c.036 2.195.039 4.387.039 6.582.022 2.201.05 4.402.082 6.603.026 1.992.035 3.984.042 5.976.019 3.45.019 3.45 1.126 7.296h-11l-1-4c-.534.36-1.067.722-1.617 1.094-5.836 3.635-10.52 5.024-17.383 3.906-3.259-1.456-5.713-3.255-8-6-.9-2.702-1.222-4.57-1.313-7.375l-.113-2.273C373 486 373 486 377 481h-16l-2.25 5.938c-2.087 5.435-4.306 10.778-6.75 16.062-1.646.027-3.292.046-4.938.063l-2.777.035C342 503 342 503 341 502l-1 18h-20v20h-20v-20h-20v-20h-20v-20h20v-20h-20v-20h20v-20h20v-20h-16v3h-12v-60h12c3.18 3.655 5.037 6.358 7.188 10.563l3.292 5.94L298 366l9 15 1-38h12v-3h20v-27h-9c-4.757-3.732-6.06-10.308-7.875-15.875a137126628.764 137126628.764 0 0 1-2.97-8.833c-1.879-5.552-3.857-11.066-5.854-16.577l-.965-2.666a4608.956 4608.956 0 0 0-3.866-10.636c-.912-2.5-1.818-5.001-2.724-7.503l-.841-2.288c-1.084-3.006-1.905-5.4-1.905-8.622h16v-20h-20v-20h15c4.534 11.944 8.776 23.932 13 36l1-110-18 7c-14.468 5-14.468 5-17 5v2h-26c-4-11-4-11-4-16 3.958-3.294 9.25-4.632 14.074-6.266l2.728-.94c1.944-.67 3.889-1.336 5.835-2.001 5.207-1.78 10.408-3.578 15.61-5.375l3.224-1.113c10.621-3.67 21.203-7.446 31.779-11.243 12.061-4.325 24.13-8.614 36.248-12.78 10.26-3.53 20.49-7.148 30.717-10.771a4089.395 4089.395 0 0 1 23.777-8.331 5594.765 5594.765 0 0 0 33.811-11.882l9.554-3.382 6.17-2.186c.937-.33 1.873-.662 2.838-1.003 4.054-1.438 8.09-2.897 12.102-4.448 3.177-1.15 5.212-1.59 8.533-1.279Z"
    />
    <path
      fill="#B0B0B1"
      d="M501 41c3.766 6.994 6.357 14.272 8.95 21.766l1.387 3.972c.964 2.76 1.924 5.52 2.882 8.28 1.226 3.535 2.458 7.067 3.692 10.599 1.182 3.382 2.36 6.765 3.538 10.149l.678 1.944a400223227.407 400223227.407 0 0 0 2.982 8.585A75.25 75.25 0 0 1 527 113l1.999-.013c6.845-.045 13.69-.075 20.535-.097 2.557-.01 5.114-.024 7.671-.04 3.669-.025 7.337-.036 11.006-.045l3.482-.032h3.215l2.84-.014C580 113 580 113 582 115c.198 2.591.27 5.076.254 7.668l.01 2.426c.007 2.698.001 5.396-.005 8.094a5339.234 5339.234 0 0 1 .01 21.528c-.005 5.48 0 10.962.002 16.444.004 9.207 0 18.414-.01 27.621-.011 10.658-.008 21.315.003 31.973.01 9.136.01 18.272.006 27.409a9216.93 9216.93 0 0 0 .003 16.388c.005 5.135.001 10.27-.01 15.405-.003 1.889-.002 3.778.002 5.667.006 2.57-.001 5.14-.011 7.709l.013 2.29c-.039 5.15-.039 5.15-2.267 7.378-1.84.254-1.84.254-4.124.26l-2.633.021-2.91-.007-3.077.016c-3.426.015-6.851.016-10.277.016-2.447.008-4.894.016-7.34.026-6.664.022-13.327.03-19.99.035-4.159.004-8.318.01-12.476.017-11.51.02-23.018.036-34.527.04h-2.233a1312723.473 1312723.473 0 0 1-6.728.002h-2.25c-12.035.004-24.07.03-36.104.068-12.35.038-24.698.057-37.047.058-6.936 0-13.872.009-20.808.038-6.522.027-13.044.028-19.566.012a975.11 975.11 0 0 0-7.194.02c-3.265.021-6.53.01-9.795-.007l-2.897.04c-6.413-.082-6.413-.082-9.578-3.047-1.367-2.466-2.436-4.736-3.313-7.413l-.975-2.902-1.033-3.168a137126628.764 137126628.764 0 0 1-2.97-8.833c-1.879-5.552-3.857-11.066-5.854-16.577l-.965-2.666a4608.956 4608.956 0 0 0-3.866-10.636c-.912-2.5-1.818-5.001-2.724-7.503l-.841-2.288c-1.084-3.006-1.905-5.4-1.905-8.622h16v-20h-20v-20h15c4.534 11.944 8.776 23.932 13 36l1-110-18 7c-14.468 5-14.468 5-17 5v2h-26c-4-11-4-11-4-16 3.958-3.294 9.25-4.632 14.074-6.266l2.728-.94c1.944-.67 3.889-1.336 5.835-2.001 5.207-1.78 10.408-3.578 15.61-5.375l3.224-1.113c10.621-3.67 21.203-7.446 31.779-11.243 12.061-4.325 24.13-8.614 36.248-12.78 10.26-3.53 20.49-7.148 30.717-10.771a4089.395 4089.395 0 0 1 23.777-8.331 5594.765 5594.765 0 0 0 33.811-11.882l9.554-3.382 6.17-2.186c.937-.33 1.873-.662 2.838-1.003 4.054-1.438 8.09-2.897 12.102-4.448 3.177-1.15 5.212-1.59 8.533-1.279Z"
    />
    <path
      fill="#F3F3F3"
      d="M360 340h20v20h20v-20h20v20h-2v43h-12v-3h-6v20h20v-20h8v-40h11v4l2.813-2.5c4.115-2.936 7.633-3.153 12.597-2.941 3.736.636 5.657 2.095 8.59 4.441 3.148.308 3.148.308 5.563-2 4.6-2.676 8.231-2.703 13.437-2 4.248 1.545 6.786 3.053 9 7 .257 2.904.35 5.586.293 8.484l-.013 2.472a944.441 944.441 0 0 1-.092 7.794 3367.49 3367.49 0 0 0-.042 5.293c-.033 4.32-.084 8.638-.146 12.957h-11l-.076-2.906c-.094-3.552-.194-7.104-.296-10.656-.044-1.538-.085-3.077-.125-4.615-.058-2.21-.122-4.419-.187-6.628l-.05-2.09c-.074-3.676-.074-3.676-1.266-7.105l-3.813-.25-2.144-.14c-2.166.216-2.166.216-3.639 1.98-1.876 3.22-1.837 5.647-1.916 9.363l-.054 2a643.375 643.375 0 0 0-.122 6.297c-.033 1.427-.067 2.854-.103 4.281-.085 3.49-.152 6.98-.209 10.469h-12v-3h-14v20h20v20h20v19c4.667-.157 4.667-.157 9.333-.36 5.082-.086 7.8 1.154 11.667 4.36 2.558 2.51 2.965 3.618 3.293 7.234l-.106 3.516-.082 3.547L504 480h10v-20h-14v-20h20v3h6l1 20 6-4c5.373-1.027 11.166-1.065 15.938 1.875 5.04 4.436 7.614 9.946 8.542 16.535.319 7.907-.814 14.105-5.48 20.59-2.625 2.5-2.625 2.5-5 4l-3 2h-4v16h-20v20h-20v-20h-20v20h-20v-20h-20v-20h-6v3h-12v-43h-2v-20h-20v20l6 1c3.552 3.256 4.784 4.807 5.644 9.555l.028 3.89.039 2.098c.036 2.195.039 4.387.039 6.582.022 2.201.05 4.402.082 6.603.026 1.992.035 3.984.042 5.976.019 3.45.019 3.45 1.126 7.296h-11l-1-4c-.534.36-1.067.722-1.617 1.094-5.836 3.635-10.52 5.024-17.383 3.906-3.259-1.456-5.713-3.255-8-6-.9-2.702-1.222-4.57-1.313-7.375l-.113-2.273C373 486 373 486 377 481h-16l-2.25 5.938A277.914 277.914 0 0 1 352 503h-10c-3.377-7.475-6.525-15.032-9.625-22.625l-1.484-3.602c-2.262-5.536-4.443-10.965-5.891-16.773h12c3.53 9.273 6.958 18.552 10 28l.734-2.457c1.961-6.48 4.043-12.87 6.434-19.203.962-2.586.962-2.586 1.832-6.34h-16v-20h20v-20h20v-20c-10.373.029-10.373.029-20.313 2.563-5.6 2.182-11.19 2.486-16.992.746-6.024-2.717-9.87-7.002-12.507-13.059-2.247-6.83-2.112-12.935.875-19.5 2.489-4.478 5.449-8.173 9.937-10.75 5.842-1.652 11.991-1.06 18-1l1-19Z"
    />
    <path
      fill="#FAFAFA"
      d="M353 137h205v143c-4.119-3.53-8.008-6.88-11.813-10.68l-2.57-2.566-2.617-2.629-2.617-2.605c-3.737-3.743-7.417-7.488-10.86-11.504-4.354-5.071-9.14-9.702-13.898-14.391a2892.083 2892.083 0 0 1-5.398-5.336l-2.389-2.353C504 226 504 226 503 224c-4.579 1.249-6.96 3.778-10.14 7.094-3.103 3.18-6.487 6.019-9.86 8.906l-3.41 2.934c-5.5 4.726-11.01 9.435-16.59 14.066-4.092-3-7.094-6.417-10.125-10.438-3.682-4.789-7.44-9.479-11.375-14.062-5.207-6.086-10.162-12.349-15.077-18.672-2.525-3.243-5.07-6.472-7.61-9.703l-2.793-3.555L414 198c-2.569.374-3.771.766-5.609 2.648-.518.712-1.037 1.423-1.57 2.157l-1.793 2.427-1.903 2.643-2.006 2.73A2088.275 2088.275 0 0 0 395 219c-2.307 3.15-4.622 6.294-6.938 9.438l-1.71 2.332c-5.126 6.969-10.377 13.838-15.641 20.701-4.399 5.753-8.685 11.569-12.794 17.532-2.712 3.894-2.712 3.894-4.917 4.997V137Z"
    />
    <path
      fill="#F4F4F4"
      d="M589 380h7l.516 2.414c1.658 7.25 3.494 12.223 8.484 17.836 4.739 2.764 9.586 3.036 15 3.75v16h20v20h20v20h20v20h20v20h20v40h-20v-20h-20v20h-20v-20h-20v20h-20v-20h-20v20h-20v-20h-20v-20h6v-57h12v17h2v-40h20v-20h-11v-20Z"
    />
    <path
      fill="#AFAFB0"
      d="M540 113c5.66-.046 11.32-.086 16.98-.11 1.926-.01 3.853-.024 5.78-.04 2.764-.025 5.53-.036 8.295-.045l2.62-.032c2.11 0 4.219.104 6.325.227 2.496 2.496 2.242 3.973 2.267 7.379l-.013 2.289.01 2.426c.007 2.698.001 5.396-.005 8.094a5339.234 5339.234 0 0 1 .01 21.528c-.005 5.48 0 10.962.002 16.444.004 9.207 0 18.414-.01 27.621-.011 10.658-.008 21.315.003 31.973.01 9.136.01 18.272.006 27.409a9216.93 9216.93 0 0 0 .003 16.388c.005 5.135.001 10.27-.01 15.405-.003 1.889-.002 3.778.002 5.667.006 2.57-.001 5.14-.011 7.709l.013 2.29c-.039 5.15-.039 5.15-2.267 7.378-1.84.254-1.84.254-4.124.26l-2.633.021-2.91-.007-3.077.016c-3.426.015-6.851.016-10.277.016-2.447.008-4.894.016-7.34.026-6.664.022-13.327.03-19.99.035-4.159.004-8.318.01-12.476.017-11.51.02-23.018.036-34.527.04h-2.233a1312723.488 1312723.488 0 0 1-8.978.002c-12.035.004-24.07.03-36.104.068-12.35.038-24.698.057-37.047.058-6.936 0-13.872.009-20.808.038-6.522.027-13.044.028-19.566.012a975.11 975.11 0 0 0-7.194.02c-3.265.021-6.53.01-9.795-.007l-2.897.04c-6.413-.082-6.413-.082-9.578-3.047-1.367-2.466-2.436-4.736-3.313-7.413l-.975-2.902-1.033-3.168a137126628.764 137126628.764 0 0 1-2.97-8.833c-1.879-5.552-3.857-11.066-5.854-16.577l-.965-2.666a4608.956 4608.956 0 0 0-3.866-10.636c-.912-2.5-1.818-5.001-2.724-7.503l-.841-2.288c-1.084-3.006-1.905-5.4-1.905-8.622h16v40h20v20h20v-20h40v20h20v-20h20v20h20v-20h20v20h20v-20h20v-20h-20v-20c17.673-1.515 17.673-1.515 22.688 2.39 3.113 2.943 5.69 6.228 8.312 9.61 8.228 9.403 17.165 18.165 26 27l1-142h-18v-24Z"
    />
    <path
      fill="#B0B0B1"
      d="M501 41c3.766 6.994 6.357 14.272 8.95 21.766l1.387 3.972c.964 2.76 1.924 5.52 2.882 8.28 1.226 3.535 2.458 7.067 3.692 10.599 1.182 3.382 2.36 6.765 3.538 10.149l.678 1.944a400223227.407 400223227.407 0 0 0 2.982 8.585c.727 2.206 1.328 4.452 1.891 6.705h13v24H440v-17h-20v-7h-53c2.686-1.79 4.663-2.66 7.688-3.625l2.449-.79c.615-.192 1.23-.386 1.863-.585l1-8h-20V90a225.703 225.703 0 0 1 18.645-7.531l2.7-.963c1.872-.667 3.745-1.333 5.62-1.997 2.83-1.003 5.66-2.011 8.49-3.02 14.742-5.25 14.742-5.25 21.42-7.446 8.759-2.883 17.432-6.015 26.122-9.098 3.224-1.144 6.449-2.286 9.674-3.427 8.967-3.176 17.932-6.352 26.86-9.635l3.515-1.289a872.958 872.958 0 0 0 6.062-2.257l2.622-.966 2.17-.815c2.431-.644 4.595-.652 7.1-.556Z"
    />
    <path
      fill="#EFEFEF"
      d="M280 420h60v40h16c-.365 6.327-2.186 11.225-4.723 17.012-1.68 3.93-2.987 7.915-4.277 11.988h-1l-.7-2.352a379.594 379.594 0 0 0-7.347-21.847C337 462 337 462 337 460h-12l2.23 5.414c2.015 4.899 4.007 9.805 5.985 14.719 1.501 3.73 3.017 7.441 4.664 11.11 4.152 9.864 3.112 18.242 2.121 28.757h-20v20h-20v-20h-20v-20h-20v-20h20v-20h-20v-20h20v-20Z"
    />
    <path
      fill="#EEE"
      d="M600 340h20v19l5 1c5.625 3.1 8.248 6.758 11.25 12.313C637 375 637 375 637 384h-29c2.683 8.606 2.683 8.606 6 10 3.458.417 3.458.417 7 0l1.336-2.035L624 390c2.918-.172 2.918-.172 6.188.25l3.292.39c.832.12 1.663.238 2.52.36-1.275 5.483-3.4 7.815-8 11-5.67 2.77-13.057 3.297-19.09 1.313-6.018-3.161-9.497-7.645-11.722-13.875-.97-3.225-1.516-6.047-1.188-9.438h-7v20h11v20h-20v20h-20l-1-20-7-3c-3.487-4.113-4-5.467-4-11l13 1 1 3c3.211 1.606 6.517 1.468 10 1 2.686-1.27 2.686-1.27 4-4 .313-3.031.233-5.965 0-9l-2.875 2.5c-3.898 2.775-7.04 3.18-11.762 2.922-4.692-.838-7.37-3.373-10.55-6.735-4.982-7.386-5.927-13.815-4.813-22.687 1.584-5.063 3.698-9.463 8.125-12.563 5.007-2.503 9.344-3.273 14.875-2.437 2.907 1.372 5.448 3.053 8 5l1-4h22v-20Z"
    />
    <path
      fill="#FEFEFE"
      d="M500 440h20v3h6l1 20 6-4c5.373-1.027 11.166-1.065 15.938 1.875 5.04 4.436 7.614 9.946 8.542 16.535.319 7.907-.814 14.105-5.48 20.59-2.625 2.5-2.625 2.5-5 4l-3 2h-4v16h-20v20h-20v-20h-20v20h-20v-40c10 0 10 0 15 3 6.924 1.035 11.266-.177 17-4h2l1 3h10l-1-3a72.848 72.848 0 0 1-.098-4.45l.01-2.568.026-2.67.013-2.705c.012-2.202.03-4.405.049-6.607h10v-20h-14v-20Z"
    />
    <path
      fill="#EFEFEF"
      d="M360 420h20v20h20v20l6 1c3.552 3.256 4.784 4.807 5.644 9.555l.028 3.89.039 2.098c.036 2.195.039 4.387.039 6.582.022 2.201.05 4.402.082 6.603.026 1.992.035 3.984.042 5.976.019 3.45.019 3.45 1.126 7.296h-11l-1-4c-.534.36-1.067.722-1.617 1.094-5.836 3.635-10.52 5.024-17.383 3.906-3.259-1.456-5.713-3.255-8-6-.9-2.702-1.222-4.57-1.313-7.375l-.113-2.273C373 486 373 486 377 481h-16l-2.25 5.938A277.914 277.914 0 0 1 352 503h-10c-3.377-7.475-6.525-15.032-9.625-22.625l-1.484-3.602c-2.262-5.536-4.443-10.965-5.891-16.773h12c3.53 9.273 6.958 18.552 10 28l.734-2.457c1.961-6.48 4.043-12.87 6.434-19.203.962-2.586.962-2.586 1.832-6.34h-16v-20h20v-20Z"
    />
    <path
      fill="#B4B4B5"
      d="M329 126v113c-2.26-3.39-3.488-6.847-4.82-10.66l-.799-2.26a1972.09 1972.09 0 0 1-1.659-4.723c-.846-2.416-1.7-4.829-2.554-7.242l-1.613-4.588-.777-2.194C315 202.231 315 202.231 315 200h-15v20h20v20l-17 1c-.594-1.818-1.189-3.635-1.8-5.508-4.779-14.521-9.76-28.93-15.076-43.265a1211.036 1211.036 0 0 1-9.562-26.852l-1.214-3.535c-2.488-7.268-4.919-14.552-7.348-21.84h26v-2a8594.34 8594.34 0 0 1 13.99-5.127c1.587-.58 3.174-1.163 4.76-1.746 2.278-.837 4.557-1.67 6.836-2.502l2.156-.795c5.03-1.83 5.03-1.83 7.258-1.83Z"
    />
    <path
      fill="#FBFBFB"
      d="M580 440h20v19l5.5-.313c6.134.008 9.978 1.14 14.5 5.313 5.535 6.992 6 10.816 6 20h-29c2.683 8.606 2.683 8.606 6 10 3.458.417 3.458.417 7 0l1.336-2.035L613 490c2.918-.172 2.918-.172 6.188.25l3.292.39c.832.12 1.663.238 2.52.36-2.17 5.642-4.004 8.984-9.563 11.813-5.012 1.64-10.23 1.952-15.437 1.187l-2.875-1.48c-5.44-2.646-11.143-2.238-17.125-2.52v20h-20v-20h6v-57h12v17h2v-20Z"
    />
    <path
      fill="#F6F6F6"
      d="M400 440h20v20h2v43h12v-3h6v40h-20v-20h-20v20h-20v-20h-20v-20l7.813-.688 2.448-.24c5.319-.399 5.319-.399 7.563 1.346L379 502c4.84 1.613 10.345 2.11 15.14.105 1.653-.982 3.26-2.039 4.86-3.105h2l1 3 11 1-2-4a99.893 99.893 0 0 1-.273-7.215l-.063-4.267c-.023-2.23-.039-4.46-.045-6.689a515.2 515.2 0 0 0-.08-6.481l-.025-3.906c-.608-4.071-1.506-5.66-4.514-8.442l-6-2v-20Z"
    />
    <path
      fill="#FAFAFA"
      d="M487 71c1.68 4.532 3.352 9.067 5.017 13.605.566 1.54 1.135 3.079 1.705 4.617.825 2.225 1.642 4.452 2.458 6.68l.764 2.047c1.797 4.94 3.021 9.9 4.056 15.051-6.404.127-12.808.215-19.214.275-2.176.025-4.353.059-6.53.102-3.137.061-6.274.09-9.412.111l-2.924.078c-5.872.003-9.447-.864-14.16-4.44-3.127-2-6.211-1.77-9.76-1.126-3.817 1.066-7.143 2.143-10 5-2.594.24-2.594.24-5.918.227h-3.761l-4.079-.032-4.161-.008c-3.653-.008-7.306-.028-10.96-.05-3.726-.02-7.453-.03-11.18-.04-7.313-.02-14.627-.055-21.941-.097 2.85-1.9 5.191-2.894 8.398-4.031l3.34-1.19 3.637-1.279a12274 12274 0 0 0 3.836-1.36c9.328-3.3 18.682-6.527 28.042-9.735 16.284-5.597 32.515-11.346 48.754-17.069l3.525-1.242a25870.42 25870.42 0 0 0 12.252-4.32C481.702 71.754 483.876 71 487 71Z"
    />
    <path
      fill="#B6B6B7"
      d="M571.367 360.117A75.86 75.86 0 0 1 577 364l1-4h10c.074 6.708.129 13.415.165 20.123.015 2.28.035 4.56.061 6.841.037 3.284.054 6.568.067 9.852.015 1.014.03 2.028.047 3.073.001 5.82-.451 10.006-3.34 15.111-5.67 4.489-10.21 5.202-17.25 5.25l-2.238.063c-5.255.037-8.862-.821-13.512-3.313-3.487-4.113-4-5.467-4-11l13 1 1 3c3.211 1.606 6.517 1.468 10 1 2.686-1.27 2.686-1.27 4-4 .313-3.031.233-5.965 0-9l-2.875 2.5c-3.898 2.775-7.04 3.18-11.762 2.922-4.692-.838-7.37-3.373-10.55-6.735-4.982-7.386-5.927-13.815-4.813-22.687 1.584-5.063 3.698-9.463 8.125-12.563 5.556-2.778 11.42-4.067 17.242-1.32Z"
    />
    <path
      fill="#F8F8F8"
      d="M329 126v113c-1.688-2.533-2.57-4.312-3.534-7.125l-.876-2.536-.942-2.769-1.004-2.916c-1.094-3.175-2.181-6.352-3.269-9.529-1.53-4.45-3.063-8.9-4.598-13.348l-1.187-3.444a2099.197 2099.197 0 0 0-8.274-23.454l-1.125-3.14a3750.866 3750.866 0 0 0-4.322-11.999c-.994-2.74-1.981-5.484-2.967-8.228l-.897-2.45C294.725 144.485 294 141.844 294 138a8594.34 8594.34 0 0 1 13.99-5.127c1.587-.58 3.174-1.163 4.76-1.746 2.278-.837 4.557-1.67 6.836-2.502l2.156-.795c5.03-1.83 5.03-1.83 7.258-1.83Z"
    />
    <path
      fill="#B1B1B2"
      d="M272 343h12c3.18 3.655 5.037 6.358 7.188 10.563l3.292 5.94L298 366l9 15 1-38h11v60h-12c-2.779-3.166-4.199-5.335-6-9a519.032 519.032 0 0 0-3.29-5.48c-1.114-1.901-2.226-3.804-3.335-5.707a3849.546 3849.546 0 0 0-3.352-5.731l-1.47-2.524c-1.765-2.907-3.667-5.729-5.553-8.558l-1 37h-11v-60Z"
    />
    <path
      fill="#B5B5B6"
      d="M515 444h11l1 19 6-4c5.373-1.027 11.166-1.065 15.938 1.875 5.04 4.436 7.614 9.946 8.542 16.535.319 7.907-.814 14.105-5.48 20.59-2.625 2.5-2.625 2.5-5 4l-3 2c-5.059.749-8.968.553-13.5-1.875C528 500 528 500 526 498l-1 5h-10v-59Z"
    />
    <path
      fill="#AEAEAF"
      d="M457 359c2.34 1.101 3.959 2.367 6 4 3.148.308 3.148.308 5.563-2 4.6-2.676 8.231-2.703 13.437-2 4.248 1.545 6.786 3.053 9 7 .257 2.904.35 5.586.293 8.484l-.013 2.472a944.441 944.441 0 0 1-.092 7.794 3367.49 3367.49 0 0 0-.042 5.293c-.033 4.32-.084 8.638-.146 12.957h-11l-.076-2.906c-.094-3.552-.194-7.104-.296-10.656-.044-1.538-.085-3.077-.125-4.615-.058-2.21-.122-4.419-.187-6.628l-.05-2.09c-.074-3.676-.074-3.676-1.266-7.105l-3.813-.25-2.144-.14c-2.166.216-2.166.216-3.639 1.98-1.876 3.22-1.837 5.647-1.916 9.363l-.054 2a643.375 643.375 0 0 0-.122 6.297c-.033 1.427-.067 2.854-.103 4.281-.085 3.49-.152 6.98-.209 10.469h-12l-.076-3.013c-.094-3.677-.194-7.354-.296-11.031-.044-1.594-.085-3.188-.125-4.781-.058-2.287-.122-4.573-.187-6.859l-.05-2.171c.184-3.36.184-3.36-1.266-6.145-5.243-.53-5.243-.53-9.938 1.25-2.282 3.76-2.236 7.736-2.378 12.047l-.127 3.652-.12 3.801-.13 3.848A3932.01 3932.01 0 0 0 439 403h-11v-43h11v4l2.813-2.5c4.76-3.397 9.536-3.463 15.187-2.5Z"
    />
    <path
      fill="#B2B2B3"
      d="M364 361.5c4.973 3.848 8.025 8.576 10 14.5.703 7.137.416 13.154-4 19-5.795 6.24-10.824 8.987-19.375 9.375-7.065-.154-11.424-2.223-16.438-7.125-4.487-6.667-6.467-13.18-5.187-21.25 2.206-6.647 5.813-12.448 12-16 7.504-2.014 16.22-2.698 23 1.5Z"
    />
    <path
      fill="#FEFEFE"
      d="m320 400 9.125-.188 2.84-.082c5.23-.052 8.386.685 13.035 3.27 6.086.895 10.943.18 16.543-2.332 5.874-1.597 12.472-.818 18.457-.668v20h-20v20h-20v-20h-20v-20Z"
    />
    <path
      fill="#ADADAE"
      d="m486.375 458.625 2.25-.074c5.258-.028 8.227.961 12.375 4.449 3.418 3.523 3.403 6.442 3.477 11.25a687.934 687.934 0 0 1 .148 8.75c.037 2.215.077 4.43.123 6.644.04 2.009.067 4.018.094 6.028.056 3.476.056 3.476 1.158 7.328h-11l-1-4-1.617 1.094c-5.802 3.613-10.554 5.16-17.383 3.906-4.406-2.163-7.164-4.411-9-9-.658-4.459-.604-7.843 1.5-11.875 6.402-5.442 15.505-6.407 23.5-8.125.043-1.666.04-3.334 0-5-1.034-1.26-1.034-1.26-3.285-1.098l-2.777.036-2.786.027L480 469l-2 4-11-1c1.433-5.603 3.85-8.855 8.64-12.117 3.527-1.32 7.02-1.252 10.735-1.258Z"
    />
    <path
      fill="#B5B5B6"
      d="M404.188 460.188c3.15 2.03 4.76 3.674 6.812 6.812.53 3.442.53 3.442.574 7.348l.043 2.102c.042 2.204.057 4.408.07 6.613.03 2.207.064 4.415.103 6.623.033 2 .05 4.001.068 6.002.037 3.463.037 3.463 1.142 7.312h-11l-1-4-1.617 1.094c-5.836 3.635-10.52 5.024-17.383 3.906-3.259-1.456-5.713-3.255-8-6-1.356-4.07-1.517-7.746-1-12 2.227-4.269 4.97-5.805 9.496-7.309 5.125-1.415 10.307-2.574 15.504-3.691.043-1.666.04-3.334 0-5-1.034-1.26-1.034-1.26-3.285-1.098l-2.777.036-2.786.027L387 469l-2 4-10-2c1.088-5.438 1.952-6.517 6-10 5.784-3.803 16.819-3.26 23.188-.813Z"
    />
    <path
      fill="#B1B1B2"
      d="m299.875 458.688 2.105-.05c4.777-.004 8.023.748 12.02 3.362 3.98 4.012 4.511 6.764 4.574 12.348l.043 2.102c.042 2.204.057 4.408.07 6.613.03 2.207.064 4.415.103 6.623.033 2 .05 4.001.068 6.002.037 3.463.037 3.463 1.142 7.312h-11l-1-4-1.617 1.094c-5.802 3.613-10.554 5.16-17.383 3.906-4.413-2.166-7.09-4.439-9-9-.4-4.477-.323-8.094 2-12 4.701-3.722 9.057-5.047 14.875-6.25l2.375-.523c1.914-.42 3.832-.825 5.75-1.227.043-1.666.04-3.334 0-5-1.034-1.26-1.034-1.26-3.285-1.098l-2.777.036-2.786.027L294 469l-2 4c-3.47-.458-6.674-.891-10-2 .416-4.848 2.374-6.88 6-10 3.711-2.492 7.556-2.332 11.875-2.313ZM519.875 358.688l2.105-.05c4.777-.004 8.023.748 12.02 3.362 3.98 4.012 4.511 6.764 4.574 12.348l.043 2.102c.042 2.204.057 4.408.07 6.613.03 2.207.064 4.415.103 6.623.033 2 .05 4.001.068 6.002.037 3.463.037 3.463 1.142 7.312h-11l-1-4-1.617 1.094c-5.802 3.613-10.554 5.16-17.383 3.906-4.413-2.166-7.09-4.439-9-9-.4-4.477-.323-8.094 2-12 4.701-3.722 9.057-5.047 14.875-6.25l2.375-.523c1.914-.42 3.832-.825 5.75-1.227.043-1.666.04-3.334 0-5-1.034-1.26-1.034-1.26-3.285-1.098l-2.778.036-2.785.027L514 369l-2 4c-3.47-.458-6.674-.891-10-2 .416-4.848 2.374-6.88 6-10 3.711-2.492 7.556-2.332 11.875-2.313Z"
    />
    <path
      fill="#ACACAD"
      d="M625.488 359.91c5.826 3.412 9.693 8.57 11.512 15.09v9h-29c2.683 8.606 2.683 8.606 6 10 3.458.417 3.458.417 7 0l1.336-2.035L624 390c2.918-.172 2.918-.172 6.188.25l3.292.39c.832.12 1.663.238 2.52.36-1.275 5.483-3.4 7.815-8 11-5.67 2.77-13.057 3.297-19.09 1.313-5.39-2.831-9.7-7.641-11.91-13.313-.758-8.545-1.24-17.715 4.395-24.738 6.466-6.86 15.025-8.669 24.093-5.352Z"
    />
    <path
      fill="#AEAEAF"
      d="M614.488 459.91c5.826 3.412 9.693 8.57 11.512 15.09v9h-29c2.683 8.606 2.683 8.606 6 10 3.458.417 3.458.417 7 0l1.336-2.035L613 490c2.918-.172 2.918-.172 6.188.25l3.292.39c.832.12 1.663.238 2.52.36-2.17 5.642-4.004 8.984-9.563 11.813-5.62 1.824-11.848 2.379-17.519.496-5.915-3.08-9.885-8.01-11.918-14.309-.767-8.342-1.076-16.908 4.395-23.742 6.474-6.852 15.022-8.666 24.093-5.348Z"
    />
    <path
      fill="#AFAFB0"
      d="M505.813 157.063c5.089 3.093 8.901 7.395 11.187 12.937.986 6.74.023 12.46-4 18-3.505 3.683-7.44 6.663-12.55 7.336-6.161.087-10.677-.23-15.45-4.336-4.47-4.55-7.142-7.676-7.25-14.188.093-5.96.827-10.345 5.16-14.757 7.25-6.501 13.308-7.666 22.902-4.993Z"
    />
    <path fill="#ECECEC" d="M420 440h20v20h-6v20h6v20h-6v3h-12v-43h-2v-20Z" />
    <path
      fill="#EFEFEF"
      d="M280 460h9l-2.375 2.688c-2.197 2.62-3.563 5.03-4.625 8.312l10 2 2-5a364.73 364.73 0 0 1 4.875-.125l2.742-.07C304 468 304 468 306 470c.125 2.625.125 2.625 0 5-4.356 2.552-9.283 3.34-14.156 4.412-3.905.914-6.913 1.783-9.844 4.588-1.495 3.488-1.262 7.27-1 11 1.286 2.979 2.607 4.644 5 6.813 4.677 1.85 8.995 1.368 14 1.187v17h-20v-20h-20v-20h20v-20ZM480 20h20v20h20v20l-12 1-1.277-3.648-1.66-4.727-.842-2.406-.81-2.305-.747-2.126c-.652-1.853-.652-1.853-1.664-3.788-5.483.533-10.32 1.572-15.492 3.504l-2.037.735a1151.98 1151.98 0 0 0-6.346 2.324c-2.136.78-4.273 1.558-6.41 2.333-1.925.699-3.847 1.404-5.77 2.11C462 54 462 54 460 54V40h20V20Z"
    />
    <path
      fill="#B0B0B1"
      d="M580 360h8c.076 6.708.129 13.415.165 20.123.015 2.28.035 4.56.061 6.841.037 3.284.054 6.568.067 9.852.015 1.014.03 2.028.047 3.073.001 5.82-.451 10.006-3.34 15.111-5.67 4.489-10.21 5.202-17.25 5.25l-2.238.063c-5.255.037-8.862-.821-13.512-3.313-3.487-4.113-4-5.467-4-11l13 1 1 3c3.211 1.606 6.517 1.468 10 1 2.686-1.27 2.686-1.27 4-4 .313-3.031.233-5.965 0-9l-2 2c-3.258.195-3.258.195-7.125.125l-3.883-.055L560 400v-9l4 2c3.611.461 5.462.288 8.688-1.438 3.134-3.473 4.138-7.095 5.312-11.562h2v-20Z"
    />
    <path
      fill="#ADADAE"
      d="M325 460h12c3.53 9.273 6.958 18.552 10 28l.664-2.316c2.605-8.798 5.822-17.216 9.336-25.684h12c-2.33 6.122-4.662 12.243-6.996 18.363-.838 2.202-1.674 4.405-2.508 6.61-2.32 6.102-4.78 12.09-7.496 18.027h-10c-3.377-7.475-6.525-15.032-9.625-22.625l-1.484-3.602c-2.262-5.536-4.443-10.965-5.891-16.773Z"
    />
    <path
      fill="#EEE"
      d="M500 360h9l-2.375 2.688c-2.197 2.62-3.563 5.03-4.625 8.312l10 2 2-5a364.73 364.73 0 0 1 4.875-.125l2.742-.07C524 368 524 368 526 370c.125 2.625.125 2.625 0 5-4.356 2.552-9.283 3.34-14.156 4.412-3.905.914-6.913 1.783-9.844 4.588-1.495 3.488-1.262 7.27-1 11 1.286 2.979 2.607 4.644 5 6.813 4.677 1.85 8.995 1.368 14 1.187v17h-20v-20h-8l-1 3v-33h1v10h8v-20Z"
    />
    <path
      fill="#F6F6F6"
      d="M480 140h20v16l-4.125.25c-6.295.72-10.84 3.74-14.84 8.691-2.323 4.62-2.467 9.997-3.035 15.059h-18v-20h20v-20Z"
    />
    <path
      fill="#FEFEFE"
      d="M600 440h20v20h20v20h-14l-1.25-4.625c-1.8-5.9-3.772-9.85-8.75-13.688-4.973-2.622-10.493-2.44-16-2.687v-19Z"
    />
    <path
      fill="#FDFDFD"
      d="M320 440h20v20h16c-.365 6.327-2.186 11.225-4.723 17.012-1.68 3.93-2.987 7.915-4.277 11.988h-1l-.7-2.352a379.594 379.594 0 0 0-7.347-21.847C337 462 337 462 337 460h-17v-20Z"
    />
    <path
      fill="#EFEFEF"
      d="M317 279c1.99 2.986 2.935 5.45 4.059 8.84l1.17 3.47c.804 2.414 1.606 4.828 2.406 7.243l1.174 3.474 1.056 3.18c1.097 2.7 2.186 4.636 4.135 6.793 2.263.692 2.263.692 4.688.75l2.449.172L340 313v7h-20v-20h-20v-20l8.375-.688 2.634-.24c1.992-.14 3.994-.11 5.991-.072Z"
    />
    <path fill="#B0B0B1" d="M566 444h11v59h-11v-59ZM445 444h11v59h-11v-59Z" />
    <path
      fill="#FEFEFE"
      d="M340 340h20v20l-10.352-.195c-5.658.303-9.964 1.78-14.261 5.57-3.54 4.148-5.087 9.424-6.387 14.625h-9v-20h20v-20Z"
    />
    <path
      fill="#AFAFB0"
      d="M515 444h11l1 19 4-3c2.36-.293 2.36-.293 4.75-.188l2.422.083L540 460v8l-1.828.043c-5.292.28-5.292.28-9.61 3.144-1.604 2.888-2.675 5.635-3.562 8.813h-5v20h5v3h-10v-59Z"
    />
    <path
      fill="#F0F0F0"
      d="M500 440h20v3h6v1h-11v59l-1-3h-8l-1 2c-.941-2.824-1.117-4.53-1.098-7.45l.01-2.568.026-2.67.013-2.705c.012-2.202.03-4.405.049-6.607h10v-20h-14v-20Z"
    />
    <path
      fill="#FEFEFE"
      d="M589 380h7l.516 2.414c1.658 7.25 3.494 12.223 8.484 17.836 4.739 2.764 9.586 3.036 15 3.75v16h-20v-20h-11v-20Z"
    />
    <path fill="#FFF" d="M440 440h20v20h-3v-17h-12v57h-5v-20h-6v-20h6v-20Z" />
    <path
      fill="#EFEFEF"
      d="M260 160h15c3.262 7.026 5.98 14.18 8.574 21.477a1243.91 1243.91 0 0 0 2.067 5.746l1.312 3.675 1.193 3.334C289 197 289 197 289 200h-9v-20h-20v-20Z"
    />
    <path
      fill="#B5B5B6"
      d="m616.75 358.875 3.547.055L623 359l-3 1c.388 5.82.69 7.96 5 12 .75 3.25.75 3.25 1 6h-6v2h-20v14c-4.44-5.92-3.538-11.91-3-19 1.102-6 4.22-10.33 9-14 3.547-2.318 6.575-2.209 10.75-2.125Z"
    />
    <path
      fill="#B4B4B5"
      d="M480 480h20v20h-8c-1.706 1.01-3.411 2.024-5.078 3.098-3.791 1.78-7.852 1.493-11.922.902-3.125-1.438-3.125-1.438-5-3v-1h10l-1-3.125c-1.794-6.381-.866-10.343 1-16.875Z"
    />
    <path fill="#ACACAD" d="M422 460h11v43h-11v-43ZM406 360h11v43h-11v-43Z" />
    <path
      fill="#FDFDFD"
      d="M355 368c3.355 2.759 6.666 5.776 7.336 10.234.096 6.165-.606 9.792-4.336 14.766-3.14 2.407-6.128 2.474-10 2-3.496-2.225-5.464-4.18-7-8-.695-5.35-.652-9.719 1.813-14.563 3.878-4.321 6.465-5.128 12.187-4.437Z"
    />
    <path
      fill="#ADADAE"
      d="M330 380h10v20h20l-.125-4.938c-.014-5.327.776-9.92 2.125-15.062h11c.804 9.643.804 9.643-2.688 14.375-4.838 5.62-9.296 9.117-16.859 9.883-6.37.264-11.255-.419-16.453-4.258-3.978-3.704-6.842-7.782-7.113-13.313-.01-2.229.046-4.459.113-6.687Z"
    />
    <path
      fill="#B5B5B6"
      d="M300 480v3h6c.605 7.012.605 7.012-1.078 9.762-1.269 1.447-2.594 2.845-3.922 4.238l-1 3c-2.604.249-5.206.475-7.813.688l-2.236.22c-5.457.42-5.457.42-7.9-1.201-2.781-4.518-2.598-9.357-1.426-14.394 4.669-7.852 11.446-6.493 19.375-5.313ZM520 380v3h6c.605 7.012.605 7.012-1.078 9.762-1.269 1.447-2.594 2.845-3.922 4.238l-1 3c-2.604.249-5.206.475-7.813.688l-2.236.22c-5.457.42-5.457.42-7.9-1.201-2.781-4.518-2.598-9.357-1.426-14.394 4.669-7.852 11.446-6.493 19.375-5.313Z"
    />
    <path fill="#EBEBEB" d="M400 340h20v20h-2v43h-1v-43h-17v-20Z" />
    <path
      fill="#EFEFEF"
      d="M318 480h2v20h21l-1 20h-20c-.438-8.813-.438-8.813-.568-11.577l-.116-2.193-.11-2.237c-.154-2.2-.154-2.2-1.206-4.993a72.848 72.848 0 0 1-.098-4.45l.01-2.568.026-2.67.013-2.705c.012-2.202.028-4.405.049-6.607Z"
    />
    <path
      fill="#EEE"
      d="M537.066 467.535c3.058.735 4.807 2.209 6.934 4.465 1.826 5.478 2.266 12.694.176 18.152-1.456 2.213-2.797 3.659-5.176 4.848-3.313.375-3.313.375-7 0-3.16-2.541-4.715-4.146-6-8-1.16-12.402-1.16-12.402 2-16.813 3.346-2.44 5.024-2.965 9.066-2.652Z"
    />
    <path
      fill="#EBEBEB"
      d="M566 443h12v57h2v20h-20v-20h6v3h11v-59h-11v-1ZM445 443h12v57h3v20h-20v-20h5v3h11v-59h-11v-1Z"
    />
    <path
      fill="#EFEFEF"
      d="M440 340h20v20h11c-4.625 4-4.625 4-8 4l-2.5-2c-4.368-3.065-9.392-2.81-14.5-2-3.027 1.816-3.027 1.816-5 4h-2l1-24Z"
    />
    <path
      fill="#ADADAE"
      d="m383.79 479.902 2.85.01 2.985.026 3.008.013c2.456.012 4.911.028 7.367.049v2l-2.809.84-3.628 1.098-3.622 1.09c-2.8.68-2.8.68-3.941 1.972a59.19 59.19 0 0 0-.063 4.063L386 495c5.843.327 5.843.327 11-2 1.02-1.318 2.023-2.65 3-4 .482 3.448.66 6.567 0 10-2.79 3.467-6.267 4.733-10.582 5.398-6.065.237-9.55-.94-14.168-4.898-2.754-3.304-2.576-7.186-2.543-11.273.434-3.295 1.918-4.992 4.293-7.227 2.453-1.226 4.05-1.114 6.79-1.098Z"
    />
    <path
      fill="#EFEFEF"
      d="M560 340h20v19h8v1h-10v5l-1.652-1.059-2.285-1.378-2.215-1.372c-3.729-1.717-3.729-1.717-11.848-2.191v-19Z"
    />
    <path
      fill="#EEE"
      d="M569.84 367.441c2.83.732 4.681 1.956 6.344 4.383 1.846 4.922 1.648 10.052.816 15.176-1.627 3.278-3.682 5.34-7 7-2.813.375-2.813.375-6 0-3.432-2.745-5.233-4.707-6-9-1.092-10.326-1.092-10.326 1.938-14.688 3.554-2.683 5.526-3.229 9.902-2.87Z"
    />
    <path
      fill="#EFEFEF"
      d="M280 340h20v20h8v22c-2.955-2.955-4.73-5.637-6.871-9.207l-1.102-1.827c-1.159-1.924-2.312-3.851-3.464-5.779-1.15-1.916-2.302-3.831-3.454-5.746-1.05-1.744-2.096-3.49-3.142-5.237a156.217 156.217 0 0 0-4.217-6.492C284 345 284 345 284 343h-4v-3Z"
    />
    <path
      fill="#B5B5B6"
      d="M400 480h11l.184 4.016.253 5.234.12 2.645.127 2.558.11 2.349c.18 2.525.18 2.525 1.206 6.198h-11c-2.2-4.398-2.519-7.186-3-12l-1 1.938c-2.593 2.673-4.493 2.889-8.125 3.156C388 496 388 496 386 494.938c-1.486-2.88-1.53-4.754-1-7.938 4.003-3.736 9.77-4.137 15-5v-2Z"
    />
    <path
      fill="#EFEFEF"
      d="M540 440h20v20h-11l-1 2-3-2c-2.05-.451-2.05-.451-4.188-.625L537 459l3-1v-18ZM360 340h20v20l-20 1v-21ZM580 440h20v19c-4.494 2.247-7.448 2.048-12.25 1.625L580 460v-20Z"
    />
    <path
      fill="#F0F0F0"
      d="M860 520h20v20h-20v-20ZM820 520h20v20h-20v-20ZM700 520h20v20h-20v-20ZM660 520h20v20h-20v-20ZM620 520h20v20h-20v-20ZM580 520h20v20h-20v-20ZM540 520h20v20h-20v-20ZM500 520h20v20h-20v-20ZM460 520h20v20h-20v-20ZM420 520h20v20h-20v-20ZM340 520h20v20h-20v-20ZM260 520h20v20h-20v-20ZM220 520h20v20h-20v-20ZM180 520h20v20h-20v-20Z"
    />
    <path fill="#FFF" d="M160 520h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M140 520h20v20h-20v-20Z" />
    <path fill="#FFF" d="M120 520h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M100 520h20v20h-20v-20Z" />
    <path fill="#FFF" d="M80 520h20v20H80v-20Z" />
    <path fill="#F0F0F0" d="M60 520h20v20H60v-20Z" />
    <path fill="#FFF" d="M40 520h20v20H40v-20Z" />
    <path fill="#F0F0F0" d="M20 520h20v20H20v-20ZM880 500h20v20h-20v-20Z" />
    <path fill="#FFF" d="M860 500h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M840 500h20v20h-20v-20Z" />
    <path
      fill="#FFF"
      d="M820 500h20v20h-20v-20ZM780 500h20v20h-20v-20ZM740 500h20v20h-20v-20ZM700 500h20v20h-20v-20Z"
    />
    <path fill="#F0F0F0" d="M680 500h20v20h-20v-20Z" />
    <path fill="#FFF" d="M660 500h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M640 500h20v20h-20v-20Z" />
    <path fill="#FFF" d="M620 500h20v20h-20v-20ZM260 500h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M240 500h20v20h-20v-20Z" />
    <path fill="#FFF" d="M220 500h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M200 500h20v20h-20v-20Z" />
    <path fill="#FFF" d="M180 500h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M160 500h20v20h-20v-20Z" />
    <path fill="#FFF" d="M140 500h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M120 500h20v20h-20v-20Z" />
    <path fill="#FFF" d="M100 500h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M80 500h20v20H80v-20Z" />
    <path fill="#FFF" d="M60 500h20v20H60v-20Z" />
    <path fill="#F0F0F0" d="M40 500h20v20H40v-20Z" />
    <path fill="#FFF" d="M20 500h20v20H20v-20Z" />
    <path fill="#F0F0F0" d="M0 500h20v20H0v-20Z" />
    <path fill="#FFF" d="M880 480h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M860 480h20v20h-20v-20Z" />
    <path fill="#FFF" d="M840 480h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M820 480h20v20h-20v-20Z" />
    <path
      fill="#FFF"
      d="M800 480h20v20h-20v-20ZM760 480h20v20h-20v-20ZM720 480h20v20h-20v-20ZM680 480h20v20h-20v-20Z"
    />
    <path fill="#F0F0F0" d="M660 480h20v20h-20v-20Z" />
    <path fill="#FFF" d="M640 480h20v20h-20v-20ZM240 480h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M220 480h20v20h-20v-20Z" />
    <path fill="#FFF" d="M200 480h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M180 480h20v20h-20v-20Z" />
    <path fill="#FFF" d="M160 480h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M140 480h20v20h-20v-20Z" />
    <path fill="#FFF" d="M120 480h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M100 480h20v20h-20v-20Z" />
    <path fill="#FFF" d="M80 480h20v20H80v-20Z" />
    <path fill="#F0F0F0" d="M60 480h20v20H60v-20Z" />
    <path fill="#FFF" d="M40 480h20v20H40v-20Z" />
    <path fill="#F0F0F0" d="M20 480h20v20H20v-20Z" />
    <path fill="#FFF" d="M0 480h20v20H0v-20Z" />
    <path fill="#F0F0F0" d="M880 460h20v20h-20v-20Z" />
    <path fill="#FFF" d="M860 460h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M840 460h20v20h-20v-20Z" />
    <path fill="#FFF" d="M820 460h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M800 460h20v20h-20v-20Z" />
    <path
      fill="#FFF"
      d="M780 460h20v20h-20v-20ZM740 460h20v20h-20v-20ZM700 460h20v20h-20v-20ZM660 460h20v20h-20v-20Z"
    />
    <path fill="#F0F0F0" d="M640 460h20v20h-20v-20Z" />
    <path fill="#FFF" d="M260 460h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M240 460h20v20h-20v-20Z" />
    <path fill="#FFF" d="M220 460h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M200 460h20v20h-20v-20Z" />
    <path fill="#FFF" d="M180 460h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M160 460h20v20h-20v-20Z" />
    <path fill="#FFF" d="M140 460h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M120 460h20v20h-20v-20Z" />
    <path fill="#FFF" d="M100 460h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M80 460h20v20H80v-20Z" />
    <path fill="#FFF" d="M60 460h20v20H60v-20Z" />
    <path fill="#F0F0F0" d="M40 460h20v20H40v-20Z" />
    <path fill="#FFF" d="M20 460h20v20H20v-20Z" />
    <path fill="#F0F0F0" d="M0 460h20v20H0v-20Z" />
    <path fill="#FFF" d="M880 440h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M860 440h20v20h-20v-20Z" />
    <path fill="#FFF" d="M840 440h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M820 440h20v20h-20v-20Z" />
    <path fill="#FFF" d="M800 440h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M780 440h20v20h-20v-20Z" />
    <path
      fill="#FFF"
      d="M760 440h20v20h-20v-20ZM720 440h20v20h-20v-20ZM680 440h20v20h-20v-20ZM640 440h20v20h-20v-20Z"
    />
    <path fill="#F0F0F0" d="M620 440h20v20h-20v-20ZM260 440h20v20h-20v-20Z" />
    <path fill="#FFF" d="M240 440h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M220 440h20v20h-20v-20Z" />
    <path fill="#FFF" d="M200 440h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M180 440h20v20h-20v-20Z" />
    <path fill="#FFF" d="M160 440h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M140 440h20v20h-20v-20Z" />
    <path fill="#FFF" d="M120 440h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M100 440h20v20h-20v-20Z" />
    <path fill="#FFF" d="M80 440h20v20H80v-20Z" />
    <path fill="#F0F0F0" d="M60 440h20v20H60v-20Z" />
    <path fill="#FFF" d="M40 440h20v20H40v-20Z" />
    <path fill="#F0F0F0" d="M20 440h20v20H20v-20Z" />
    <path fill="#FFF" d="M0 440h20v20H0v-20Z" />
    <path fill="#F0F0F0" d="M880 420h20v20h-20v-20Z" />
    <path fill="#FFF" d="M860 420h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M840 420h20v20h-20v-20Z" />
    <path fill="#FFF" d="M820 420h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M800 420h20v20h-20v-20Z" />
    <path fill="#FFF" d="M780 420h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M760 420h20v20h-20v-20Z" />
    <path
      fill="#FFF"
      d="M740 420h20v20h-20v-20ZM700 420h20v20h-20v-20ZM660 420h20v20h-20v-20ZM620 420h20v20h-20v-20ZM580 420h20v20h-20v-20ZM540 420h20v20h-20v-20ZM500 420h20v20h-20v-20Z"
    />
    <path fill="#F0F0F0" d="M480 420h20v20h-20v-20Z" />
    <path fill="#FFF" d="M460 420h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M440 420h20v20h-20v-20Z" />
    <path fill="#FFF" d="M420 420h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M400 420h20v20h-20v-20Z" />
    <path fill="#FFF" d="M380 420h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M320 420h20v20h-20v-20Z" />
    <path fill="#FFF" d="M300 420h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M280 420h20v20h-20v-20ZM240 420h20v20h-20v-20Z" />
    <path fill="#FFF" d="M220 420h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M200 420h20v20h-20v-20Z" />
    <path fill="#FFF" d="M180 420h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M160 420h20v20h-20v-20Z" />
    <path fill="#FFF" d="M140 420h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M120 420h20v20h-20v-20Z" />
    <path fill="#FFF" d="M100 420h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M80 420h20v20H80v-20Z" />
    <path fill="#FFF" d="M60 420h20v20H60v-20Z" />
    <path fill="#F0F0F0" d="M40 420h20v20H40v-20Z" />
    <path fill="#FFF" d="M20 420h20v20H20v-20Z" />
    <path fill="#F0F0F0" d="M0 420h20v20H0v-20Z" />
    <path fill="#FFF" d="M880 400h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M860 400h20v20h-20v-20Z" />
    <path fill="#FFF" d="M840 400h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M820 400h20v20h-20v-20Z" />
    <path fill="#FFF" d="M800 400h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M780 400h20v20h-20v-20Z" />
    <path fill="#FFF" d="M760 400h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M740 400h20v20h-20v-20Z" />
    <path fill="#FFF" d="M720 400h20v20h-20v-20ZM680 400h20v20h-20v-20ZM640 400h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M380 400h20v20h-20v-20ZM220 400h20v20h-20v-20Z" />
    <path fill="#FFF" d="M200 400h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M180 400h20v20h-20v-20Z" />
    <path fill="#FFF" d="M160 400h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M140 400h20v20h-20v-20Z" />
    <path fill="#FFF" d="M120 400h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M100 400h20v20h-20v-20Z" />
    <path fill="#FFF" d="M80 400h20v20H80v-20Z" />
    <path fill="#F0F0F0" d="M60 400h20v20H60v-20Z" />
    <path fill="#FFF" d="M40 400h20v20H40v-20Z" />
    <path fill="#F0F0F0" d="M20 400h20v20H20v-20Z" />
    <path fill="#FFF" d="M0 400h20v20H0v-20Z" />
    <path fill="#F0F0F0" d="M880 380h20v20h-20v-20Z" />
    <path fill="#FFF" d="M860 380h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M840 380h20v20h-20v-20Z" />
    <path fill="#FFF" d="M820 380h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M800 380h20v20h-20v-20Z" />
    <path fill="#FFF" d="M780 380h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M760 380h20v20h-20v-20Z" />
    <path fill="#FFF" d="M740 380h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M720 380h20v20h-20v-20Z" />
    <path fill="#FFF" d="M700 380h20v20h-20v-20ZM660 380h20v20h-20v-20ZM380 380h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M240 380h20v20h-20v-20Z" />
    <path fill="#FFF" d="M220 380h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M200 380h20v20h-20v-20Z" />
    <path fill="#FFF" d="M180 380h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M160 380h20v20h-20v-20Z" />
    <path fill="#FFF" d="M140 380h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M120 380h20v20h-20v-20Z" />
    <path fill="#FFF" d="M100 380h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M80 380h20v20H80v-20Z" />
    <path fill="#FFF" d="M60 380h20v20H60v-20Z" />
    <path fill="#F0F0F0" d="M40 380h20v20H40v-20Z" />
    <path fill="#FFF" d="M20 380h20v20H20v-20Z" />
    <path fill="#F0F0F0" d="M0 380h20v20H0v-20Z" />
    <path fill="#FFF" d="M880 360h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M860 360h20v20h-20v-20Z" />
    <path fill="#FFF" d="M840 360h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M820 360h20v20h-20v-20Z" />
    <path fill="#FFF" d="M800 360h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M780 360h20v20h-20v-20Z" />
    <path fill="#FFF" d="M760 360h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M740 360h20v20h-20v-20Z" />
    <path fill="#FFF" d="M720 360h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M700 360h20v20h-20v-20Z" />
    <path fill="#FFF" d="M680 360h20v20h-20v-20ZM640 360h20v20h-20v-20ZM240 360h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M220 360h20v20h-20v-20Z" />
    <path fill="#FFF" d="M200 360h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M180 360h20v20h-20v-20Z" />
    <path fill="#FFF" d="M160 360h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M140 360h20v20h-20v-20Z" />
    <path fill="#FFF" d="M120 360h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M100 360h20v20h-20v-20Z" />
    <path fill="#FFF" d="M80 360h20v20H80v-20Z" />
    <path fill="#F0F0F0" d="M60 360h20v20H60v-20Z" />
    <path fill="#FFF" d="M40 360h20v20H40v-20Z" />
    <path fill="#F0F0F0" d="M20 360h20v20H20v-20Z" />
    <path fill="#FFF" d="M0 360h20v20H0v-20Z" />
    <path fill="#F0F0F0" d="M880 340h20v20h-20v-20Z" />
    <path fill="#FFF" d="M860 340h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M840 340h20v20h-20v-20Z" />
    <path fill="#FFF" d="M820 340h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M800 340h20v20h-20v-20Z" />
    <path fill="#FFF" d="M780 340h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M760 340h20v20h-20v-20Z" />
    <path fill="#FFF" d="M740 340h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M720 340h20v20h-20v-20Z" />
    <path fill="#FFF" d="M700 340h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M680 340h20v20h-20v-20Z" />
    <path fill="#FFF" d="M660 340h20v20h-20v-20Z" />
    <path fill="#FEFEFE" d="M540 340h20v20h-20v-20Z" />
    <path fill="#FFF" d="M380 340h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M240 340h20v20h-20v-20Z" />
    <path fill="#FFF" d="M220 340h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M200 340h20v20h-20v-20Z" />
    <path fill="#FFF" d="M180 340h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M160 340h20v20h-20v-20Z" />
    <path fill="#FFF" d="M140 340h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M120 340h20v20h-20v-20Z" />
    <path fill="#FFF" d="M100 340h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M80 340h20v20H80v-20Z" />
    <path fill="#FFF" d="M60 340h20v20H60v-20Z" />
    <path fill="#F0F0F0" d="M40 340h20v20H40v-20Z" />
    <path fill="#FFF" d="M20 340h20v20H20v-20Z" />
    <path fill="#F0F0F0" d="M0 340h20v20H0v-20Z" />
    <path fill="#FFF" d="M880 320h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M860 320h20v20h-20v-20Z" />
    <path fill="#FFF" d="M840 320h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M820 320h20v20h-20v-20Z" />
    <path fill="#FFF" d="M800 320h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M780 320h20v20h-20v-20Z" />
    <path fill="#FFF" d="M760 320h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M740 320h20v20h-20v-20Z" />
    <path fill="#FFF" d="M720 320h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M700 320h20v20h-20v-20Z" />
    <path fill="#FFF" d="M680 320h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M660 320h20v20h-20v-20Z" />
    <path fill="#FFF" d="M640 320h20v20h-20v-20ZM600 320h20v20h-20v-20ZM560 320h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M540 320h20v20h-20v-20Z" />
    <path fill="#FFF" d="M520 320h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M500 320h20v20h-20v-20ZM460 320h20v20h-20v-20Z" />
    <path fill="#FFF" d="M440 320h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M420 320h20v20h-20v-20Z" />
    <path fill="#FFF" d="M400 320h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M380 320h20v20h-20v-20Z" />
    <path fill="#FFF" d="M360 320h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M340 320h20v20h-20v-20Z" />
    <path fill="#FFF" d="M320 320h20v20h-20v-20ZM280 320h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M260 320h20v20h-20v-20Z" />
    <path fill="#FFF" d="M240 320h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M220 320h20v20h-20v-20Z" />
    <path fill="#FFF" d="M200 320h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M180 320h20v20h-20v-20Z" />
    <path fill="#FFF" d="M160 320h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M140 320h20v20h-20v-20Z" />
    <path fill="#FFF" d="M120 320h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M100 320h20v20h-20v-20Z" />
    <path fill="#FFF" d="M80 320h20v20H80v-20Z" />
    <path fill="#F0F0F0" d="M60 320h20v20H60v-20Z" />
    <path fill="#FFF" d="M40 320h20v20H40v-20Z" />
    <path fill="#F0F0F0" d="M20 320h20v20H20v-20Z" />
    <path fill="#FFF" d="M0 320h20v20H0v-20Z" />
    <path fill="#F0F0F0" d="M880 300h20v20h-20v-20Z" />
    <path fill="#FFF" d="M860 300h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M840 300h20v20h-20v-20Z" />
    <path fill="#FFF" d="M820 300h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M800 300h20v20h-20v-20Z" />
    <path fill="#FFF" d="M780 300h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M760 300h20v20h-20v-20Z" />
    <path fill="#FFF" d="M740 300h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M720 300h20v20h-20v-20Z" />
    <path fill="#FFF" d="M700 300h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M680 300h20v20h-20v-20Z" />
    <path fill="#FFF" d="M660 300h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M640 300h20v20h-20v-20Z" />
    <path fill="#FFF" d="M620 300h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M600 300h20v20h-20v-20Z" />
    <path fill="#FFF" d="M300 300h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M280 300h20v20h-20v-20Z" />
    <path fill="#FFF" d="M260 300h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M240 300h20v20h-20v-20Z" />
    <path fill="#FFF" d="M220 300h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M200 300h20v20h-20v-20Z" />
    <path fill="#FFF" d="M180 300h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M160 300h20v20h-20v-20Z" />
    <path fill="#FFF" d="M140 300h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M120 300h20v20h-20v-20Z" />
    <path fill="#FFF" d="M100 300h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M80 300h20v20H80v-20Z" />
    <path fill="#FFF" d="M60 300h20v20H60v-20Z" />
    <path fill="#F0F0F0" d="M40 300h20v20H40v-20Z" />
    <path fill="#FFF" d="M20 300h20v20H20v-20Z" />
    <path fill="#F0F0F0" d="M0 300h20v20H0v-20Z" />
    <path fill="#FFF" d="M880 280h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M860 280h20v20h-20v-20Z" />
    <path fill="#FFF" d="M840 280h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M820 280h20v20h-20v-20Z" />
    <path fill="#FFF" d="M800 280h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M780 280h20v20h-20v-20Z" />
    <path fill="#FFF" d="M760 280h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M740 280h20v20h-20v-20Z" />
    <path fill="#FFF" d="M720 280h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M700 280h20v20h-20v-20Z" />
    <path fill="#FFF" d="M680 280h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M660 280h20v20h-20v-20Z" />
    <path fill="#FFF" d="M640 280h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M620 280h20v20h-20v-20Z" />
    <path fill="#FFF" d="M600 280h20v20h-20v-20ZM280 280h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M260 280h20v20h-20v-20Z" />
    <path fill="#FFF" d="M240 280h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M220 280h20v20h-20v-20Z" />
    <path fill="#FFF" d="M200 280h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M180 280h20v20h-20v-20Z" />
    <path fill="#FFF" d="M160 280h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M140 280h20v20h-20v-20Z" />
    <path fill="#FFF" d="M120 280h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M100 280h20v20h-20v-20Z" />
    <path fill="#FFF" d="M80 280h20v20H80v-20Z" />
    <path fill="#F0F0F0" d="M60 280h20v20H60v-20Z" />
    <path fill="#FFF" d="M40 280h20v20H40v-20Z" />
    <path fill="#F0F0F0" d="M20 280h20v20H20v-20Z" />
    <path fill="#FFF" d="M0 280h20v20H0v-20Z" />
    <path fill="#F0F0F0" d="M880 260h20v20h-20v-20Z" />
    <path fill="#FFF" d="M860 260h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M840 260h20v20h-20v-20Z" />
    <path fill="#FFF" d="M820 260h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M800 260h20v20h-20v-20Z" />
    <path fill="#FFF" d="M780 260h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M760 260h20v20h-20v-20Z" />
    <path fill="#FFF" d="M740 260h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M720 260h20v20h-20v-20Z" />
    <path fill="#FFF" d="M700 260h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M680 260h20v20h-20v-20Z" />
    <path fill="#FFF" d="M660 260h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M640 260h20v20h-20v-20Z" />
    <path fill="#FFF" d="M620 260h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M600 260h20v20h-20v-20Z" />
    <path fill="#ACACAD" d="M400 260h20v20h-20v-20Z" />
    <path fill="#FFF" d="M260 260h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M240 260h20v20h-20v-20Z" />
    <path fill="#FFF" d="M220 260h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M200 260h20v20h-20v-20Z" />
    <path fill="#FFF" d="M180 260h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M160 260h20v20h-20v-20Z" />
    <path fill="#FFF" d="M140 260h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M120 260h20v20h-20v-20Z" />
    <path fill="#FFF" d="M100 260h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M80 260h20v20H80v-20Z" />
    <path fill="#FFF" d="M60 260h20v20H60v-20Z" />
    <path fill="#F0F0F0" d="M40 260h20v20H40v-20Z" />
    <path fill="#FFF" d="M20 260h20v20H20v-20Z" />
    <path fill="#F0F0F0" d="M0 260h20v20H0v-20Z" />
    <path fill="#FFF" d="M880 240h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M860 240h20v20h-20v-20Z" />
    <path fill="#FFF" d="M840 240h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M820 240h20v20h-20v-20Z" />
    <path fill="#FFF" d="M800 240h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M780 240h20v20h-20v-20Z" />
    <path fill="#FFF" d="M760 240h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M740 240h20v20h-20v-20Z" />
    <path fill="#FFF" d="M720 240h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M700 240h20v20h-20v-20Z" />
    <path fill="#FFF" d="M680 240h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M660 240h20v20h-20v-20Z" />
    <path fill="#FFF" d="M640 240h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M620 240h20v20h-20v-20Z" />
    <path fill="#FFF" d="M600 240h20v20h-20v-20Z" />
    <path fill="#ACACAD" d="M380 240h20v20h-20v-20Z" />
    <path fill="#FFF" d="M280 240h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M260 240h20v20h-20v-20Z" />
    <path fill="#FFF" d="M240 240h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M220 240h20v20h-20v-20Z" />
    <path fill="#FFF" d="M200 240h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M180 240h20v20h-20v-20Z" />
    <path fill="#FFF" d="M160 240h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M140 240h20v20h-20v-20Z" />
    <path fill="#FFF" d="M120 240h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M100 240h20v20h-20v-20Z" />
    <path fill="#FFF" d="M80 240h20v20H80v-20Z" />
    <path fill="#F0F0F0" d="M60 240h20v20H60v-20Z" />
    <path fill="#FFF" d="M40 240h20v20H40v-20Z" />
    <path fill="#F0F0F0" d="M20 240h20v20H20v-20Z" />
    <path fill="#FFF" d="M0 240h20v20H0v-20Z" />
    <path fill="#F0F0F0" d="M880 220h20v20h-20v-20Z" />
    <path fill="#FFF" d="M860 220h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M840 220h20v20h-20v-20Z" />
    <path fill="#FFF" d="M820 220h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M800 220h20v20h-20v-20Z" />
    <path fill="#FFF" d="M780 220h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M760 220h20v20h-20v-20Z" />
    <path fill="#FFF" d="M740 220h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M720 220h20v20h-20v-20Z" />
    <path fill="#FFF" d="M700 220h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M680 220h20v20h-20v-20Z" />
    <path fill="#FFF" d="M660 220h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M640 220h20v20h-20v-20Z" />
    <path fill="#FFF" d="M620 220h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M600 220h20v20h-20v-20Z" />
    <path fill="#ACACAD" d="M400 220h20v20h-20v-20Z" />
    <path fill="#FFF" d="M260 220h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M240 220h20v20h-20v-20Z" />
    <path fill="#FFF" d="M220 220h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M200 220h20v20h-20v-20Z" />
    <path fill="#FFF" d="M180 220h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M160 220h20v20h-20v-20Z" />
    <path fill="#FFF" d="M140 220h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M120 220h20v20h-20v-20Z" />
    <path fill="#FFF" d="M100 220h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M80 220h20v20H80v-20Z" />
    <path fill="#FFF" d="M60 220h20v20H60v-20Z" />
    <path fill="#F0F0F0" d="M40 220h20v20H40v-20Z" />
    <path fill="#FFF" d="M20 220h20v20H20v-20Z" />
    <path fill="#F0F0F0" d="M0 220h20v20H0v-20Z" />
    <path fill="#FFF" d="M880 200h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M860 200h20v20h-20v-20Z" />
    <path fill="#FFF" d="M840 200h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M820 200h20v20h-20v-20Z" />
    <path fill="#FFF" d="M800 200h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M780 200h20v20h-20v-20Z" />
    <path fill="#FFF" d="M760 200h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M740 200h20v20h-20v-20Z" />
    <path fill="#FFF" d="M720 200h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M700 200h20v20h-20v-20Z" />
    <path fill="#FFF" d="M680 200h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M660 200h20v20h-20v-20Z" />
    <path fill="#FFF" d="M640 200h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M620 200h20v20h-20v-20Z" />
    <path fill="#FFF" d="M600 200h20v20h-20v-20ZM240 200h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M220 200h20v20h-20v-20Z" />
    <path fill="#FFF" d="M200 200h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M180 200h20v20h-20v-20Z" />
    <path fill="#FFF" d="M160 200h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M140 200h20v20h-20v-20Z" />
    <path fill="#FFF" d="M120 200h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M100 200h20v20h-20v-20Z" />
    <path fill="#FFF" d="M80 200h20v20H80v-20Z" />
    <path fill="#F0F0F0" d="M60 200h20v20H60v-20Z" />
    <path fill="#FFF" d="M40 200h20v20H40v-20Z" />
    <path fill="#F0F0F0" d="M20 200h20v20H20v-20Z" />
    <path fill="#FFF" d="M0 200h20v20H0v-20Z" />
    <path fill="#F0F0F0" d="M880 180h20v20h-20v-20Z" />
    <path fill="#FFF" d="M860 180h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M840 180h20v20h-20v-20Z" />
    <path fill="#FFF" d="M820 180h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M800 180h20v20h-20v-20Z" />
    <path fill="#FFF" d="M780 180h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M760 180h20v20h-20v-20Z" />
    <path fill="#FFF" d="M740 180h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M720 180h20v20h-20v-20Z" />
    <path fill="#FFF" d="M700 180h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M680 180h20v20h-20v-20Z" />
    <path fill="#FFF" d="M660 180h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M640 180h20v20h-20v-20Z" />
    <path fill="#FFF" d="M620 180h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M600 180h20v20h-20v-20Z" />
    <path fill="#FFF" d="M260 180h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M240 180h20v20h-20v-20Z" />
    <path fill="#FFF" d="M220 180h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M200 180h20v20h-20v-20Z" />
    <path fill="#FFF" d="M180 180h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M160 180h20v20h-20v-20Z" />
    <path fill="#FFF" d="M140 180h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M120 180h20v20h-20v-20Z" />
    <path fill="#FFF" d="M100 180h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M80 180h20v20H80v-20Z" />
    <path fill="#FFF" d="M60 180h20v20H60v-20Z" />
    <path fill="#F0F0F0" d="M40 180h20v20H40v-20Z" />
    <path fill="#FFF" d="M20 180h20v20H20v-20Z" />
    <path fill="#F0F0F0" d="M0 180h20v20H0v-20Z" />
    <path fill="#FFF" d="M880 160h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M860 160h20v20h-20v-20Z" />
    <path fill="#FFF" d="M840 160h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M820 160h20v20h-20v-20Z" />
    <path fill="#FFF" d="M800 160h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M780 160h20v20h-20v-20Z" />
    <path fill="#FFF" d="M760 160h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M740 160h20v20h-20v-20Z" />
    <path fill="#FFF" d="M720 160h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M700 160h20v20h-20v-20Z" />
    <path fill="#FFF" d="M680 160h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M660 160h20v20h-20v-20Z" />
    <path fill="#FFF" d="M640 160h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M620 160h20v20h-20v-20Z" />
    <path fill="#FFF" d="M600 160h20v20h-20v-20ZM360 160h20v20h-20v-20ZM240 160h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M220 160h20v20h-20v-20Z" />
    <path fill="#FFF" d="M200 160h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M180 160h20v20h-20v-20Z" />
    <path fill="#FFF" d="M160 160h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M140 160h20v20h-20v-20Z" />
    <path fill="#FFF" d="M120 160h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M100 160h20v20h-20v-20Z" />
    <path fill="#FFF" d="M80 160h20v20H80v-20Z" />
    <path fill="#F0F0F0" d="M60 160h20v20H60v-20Z" />
    <path fill="#FFF" d="M40 160h20v20H40v-20Z" />
    <path fill="#F0F0F0" d="M20 160h20v20H20v-20Z" />
    <path fill="#FFF" d="M0 160h20v20H0v-20Z" />
    <path fill="#F0F0F0" d="M880 140h20v20h-20v-20Z" />
    <path fill="#FFF" d="M860 140h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M840 140h20v20h-20v-20Z" />
    <path fill="#FFF" d="M820 140h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M800 140h20v20h-20v-20Z" />
    <path fill="#FFF" d="M780 140h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M760 140h20v20h-20v-20Z" />
    <path fill="#FFF" d="M740 140h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M720 140h20v20h-20v-20Z" />
    <path fill="#FFF" d="M700 140h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M680 140h20v20h-20v-20Z" />
    <path fill="#FFF" d="M660 140h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M640 140h20v20h-20v-20Z" />
    <path fill="#FFF" d="M620 140h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M600 140h20v20h-20v-20Z" />
    <path fill="#F7F7F7" d="M400 140h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M240 140h20v20h-20v-20Z" />
    <path fill="#FFF" d="M220 140h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M200 140h20v20h-20v-20Z" />
    <path fill="#FFF" d="M180 140h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M160 140h20v20h-20v-20Z" />
    <path fill="#FFF" d="M140 140h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M120 140h20v20h-20v-20Z" />
    <path fill="#FFF" d="M100 140h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M80 140h20v20H80v-20Z" />
    <path fill="#FFF" d="M60 140h20v20H60v-20Z" />
    <path fill="#F0F0F0" d="M40 140h20v20H40v-20Z" />
    <path fill="#FFF" d="M20 140h20v20H20v-20Z" />
    <path fill="#F0F0F0" d="M0 140h20v20H0v-20Z" />
    <path fill="#FFF" d="M880 120h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M860 120h20v20h-20v-20Z" />
    <path fill="#FFF" d="M840 120h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M820 120h20v20h-20v-20Z" />
    <path fill="#FFF" d="M800 120h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M780 120h20v20h-20v-20Z" />
    <path fill="#FFF" d="M760 120h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M740 120h20v20h-20v-20Z" />
    <path fill="#FFF" d="M720 120h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M700 120h20v20h-20v-20Z" />
    <path fill="#FFF" d="M680 120h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M660 120h20v20h-20v-20Z" />
    <path fill="#FFF" d="M640 120h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M620 120h20v20h-20v-20Z" />
    <path fill="#FFF" d="M600 120h20v20h-20v-20Z" />
    <path fill="#B4B4B5" d="M560 120h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M220 120h20v20h-20v-20Z" />
    <path fill="#FFF" d="M200 120h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M180 120h20v20h-20v-20Z" />
    <path fill="#FFF" d="M160 120h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M140 120h20v20h-20v-20Z" />
    <path fill="#FFF" d="M120 120h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M100 120h20v20h-20v-20Z" />
    <path fill="#FFF" d="M80 120h20v20H80v-20Z" />
    <path fill="#F0F0F0" d="M60 120h20v20H60v-20Z" />
    <path fill="#FFF" d="M40 120h20v20H40v-20Z" />
    <path fill="#F0F0F0" d="M20 120h20v20H20v-20Z" />
    <path fill="#FFF" d="M0 120h20v20H0v-20Z" />
    <path fill="#F0F0F0" d="M880 100h20v20h-20v-20Z" />
    <path fill="#FFF" d="M860 100h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M840 100h20v20h-20v-20Z" />
    <path fill="#FFF" d="M820 100h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M800 100h20v20h-20v-20Z" />
    <path fill="#FFF" d="M780 100h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M760 100h20v20h-20v-20Z" />
    <path fill="#FFF" d="M740 100h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M720 100h20v20h-20v-20Z" />
    <path fill="#FFF" d="M700 100h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M680 100h20v20h-20v-20Z" />
    <path fill="#FFF" d="M660 100h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M640 100h20v20h-20v-20Z" />
    <path fill="#FFF" d="M620 100h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M600 100h20v20h-20v-20Z" />
    <path fill="#B4B4B5" d="M340 100h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M240 100h20v20h-20v-20Z" />
    <path fill="#FFF" d="M220 100h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M200 100h20v20h-20v-20Z" />
    <path fill="#FFF" d="M180 100h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M160 100h20v20h-20v-20Z" />
    <path fill="#FFF" d="M140 100h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M120 100h20v20h-20v-20Z" />
    <path fill="#FFF" d="M100 100h20v20h-20v-20Z" />
    <path fill="#F0F0F0" d="M80 100h20v20H80v-20Z" />
    <path fill="#FFF" d="M60 100h20v20H60v-20Z" />
    <path fill="#F0F0F0" d="M40 100h20v20H40v-20Z" />
    <path fill="#FFF" d="M20 100h20v20H20v-20Z" />
    <path fill="#F0F0F0" d="M0 100h20v20H0v-20Z" />
    <path fill="#FFF" d="M880 80h20v20h-20V80Z" />
    <path fill="#F0F0F0" d="M860 80h20v20h-20V80Z" />
    <path fill="#FFF" d="M840 80h20v20h-20V80Z" />
    <path fill="#F0F0F0" d="M820 80h20v20h-20V80Z" />
    <path fill="#FFF" d="M800 80h20v20h-20V80Z" />
    <path fill="#F0F0F0" d="M780 80h20v20h-20V80Z" />
    <path fill="#FFF" d="M760 80h20v20h-20V80Z" />
    <path fill="#F0F0F0" d="M740 80h20v20h-20V80Z" />
    <path fill="#FFF" d="M720 80h20v20h-20V80Z" />
    <path fill="#F0F0F0" d="M700 80h20v20h-20V80Z" />
    <path fill="#FFF" d="M680 80h20v20h-20V80Z" />
    <path fill="#F0F0F0" d="M660 80h20v20h-20V80Z" />
    <path fill="#FFF" d="M640 80h20v20h-20V80Z" />
    <path fill="#F0F0F0" d="M620 80h20v20h-20V80Z" />
    <path fill="#FFF" d="M600 80h20v20h-20V80Z" />
    <path fill="#F0F0F0" d="M580 80h20v20h-20V80Z" />
    <path fill="#FFF" d="M560 80h20v20h-20V80Z" />
    <path fill="#F0F0F0" d="M540 80h20v20h-20V80ZM300 80h20v20h-20V80Z" />
    <path fill="#FFF" d="M280 80h20v20h-20V80Z" />
    <path fill="#F0F0F0" d="M260 80h20v20h-20V80Z" />
    <path fill="#FFF" d="M240 80h20v20h-20V80Z" />
    <path fill="#F0F0F0" d="M220 80h20v20h-20V80Z" />
    <path fill="#FFF" d="M200 80h20v20h-20V80Z" />
    <path fill="#F0F0F0" d="M180 80h20v20h-20V80Z" />
    <path fill="#FFF" d="M160 80h20v20h-20V80Z" />
    <path fill="#F0F0F0" d="M140 80h20v20h-20V80Z" />
    <path fill="#FFF" d="M120 80h20v20h-20V80Z" />
    <path fill="#F0F0F0" d="M100 80h20v20h-20V80Z" />
    <path fill="#FFF" d="M80 80h20v20H80V80Z" />
    <path fill="#F0F0F0" d="M60 80h20v20H60V80Z" />
    <path fill="#FFF" d="M40 80h20v20H40V80Z" />
    <path fill="#F0F0F0" d="M20 80h20v20H20V80Z" />
    <path fill="#FFF" d="M0 80h20v20H0V80Z" />
    <path fill="#F0F0F0" d="M880 60h20v20h-20V60Z" />
    <path fill="#FFF" d="M860 60h20v20h-20V60Z" />
    <path fill="#F0F0F0" d="M840 60h20v20h-20V60Z" />
    <path fill="#FFF" d="M820 60h20v20h-20V60Z" />
    <path fill="#F0F0F0" d="M800 60h20v20h-20V60Z" />
    <path fill="#FFF" d="M780 60h20v20h-20V60Z" />
    <path fill="#F0F0F0" d="M760 60h20v20h-20V60Z" />
    <path fill="#FFF" d="M740 60h20v20h-20V60Z" />
    <path fill="#F0F0F0" d="M720 60h20v20h-20V60Z" />
    <path fill="#FFF" d="M700 60h20v20h-20V60Z" />
    <path fill="#F0F0F0" d="M680 60h20v20h-20V60Z" />
    <path fill="#FFF" d="M660 60h20v20h-20V60Z" />
    <path fill="#F0F0F0" d="M640 60h20v20h-20V60Z" />
    <path fill="#FFF" d="M620 60h20v20h-20V60Z" />
    <path fill="#F0F0F0" d="M600 60h20v20h-20V60Z" />
    <path fill="#FFF" d="M580 60h20v20h-20V60Z" />
    <path fill="#F0F0F0" d="M560 60h20v20h-20V60Z" />
    <path fill="#FFF" d="M540 60h20v20h-20V60Z" />
    <path fill="#F0F0F0" d="M520 60h20v20h-20V60ZM360 60h20v20h-20V60Z" />
    <path fill="#FFF" d="M340 60h20v20h-20V60Z" />
    <path fill="#F0F0F0" d="M320 60h20v20h-20V60Z" />
    <path fill="#FFF" d="M300 60h20v20h-20V60Z" />
    <path fill="#F0F0F0" d="M280 60h20v20h-20V60Z" />
    <path fill="#FFF" d="M260 60h20v20h-20V60Z" />
    <path fill="#F0F0F0" d="M240 60h20v20h-20V60Z" />
    <path fill="#FFF" d="M220 60h20v20h-20V60Z" />
    <path fill="#F0F0F0" d="M200 60h20v20h-20V60Z" />
    <path fill="#FFF" d="M180 60h20v20h-20V60Z" />
    <path fill="#F0F0F0" d="M160 60h20v20h-20V60Z" />
    <path fill="#FFF" d="M140 60h20v20h-20V60Z" />
    <path fill="#F0F0F0" d="M120 60h20v20h-20V60Z" />
    <path fill="#FFF" d="M100 60h20v20h-20V60Z" />
    <path fill="#F0F0F0" d="M80 60h20v20H80V60Z" />
    <path fill="#FFF" d="M60 60h20v20H60V60Z" />
    <path fill="#F0F0F0" d="M40 60h20v20H40V60Z" />
    <path fill="#FFF" d="M20 60h20v20H20V60Z" />
    <path fill="#F0F0F0" d="M0 60h20v20H0V60Z" />
    <path fill="#FFF" d="M880 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M860 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M840 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M820 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M800 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M780 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M760 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M740 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M720 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M700 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M680 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M660 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M640 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M620 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M600 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M580 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M560 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M540 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M520 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M420 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M400 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M380 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M360 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M340 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M320 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M300 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M280 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M260 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M240 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M220 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M200 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M180 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M160 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M140 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M120 40h20v20h-20V40Z" />
    <path fill="#F0F0F0" d="M100 40h20v20h-20V40Z" />
    <path fill="#FFF" d="M80 40h20v20H80V40Z" />
    <path fill="#F0F0F0" d="M60 40h20v20H60V40Z" />
    <path fill="#FFF" d="M40 40h20v20H40V40Z" />
    <path fill="#F0F0F0" d="M20 40h20v20H20V40Z" />
    <path fill="#FFF" d="M0 40h20v20H0V40Z" />
    <path fill="#F0F0F0" d="M880 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M860 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M840 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M820 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M800 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M780 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M760 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M740 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M720 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M700 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M680 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M660 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M640 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M620 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M600 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M580 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M560 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M540 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M520 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M500 20h20v20h-20V20ZM460 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M440 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M420 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M400 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M380 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M360 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M340 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M320 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M300 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M280 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M260 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M240 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M220 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M200 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M180 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M160 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M140 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M120 20h20v20h-20V20Z" />
    <path fill="#FFF" d="M100 20h20v20h-20V20Z" />
    <path fill="#F0F0F0" d="M80 20h20v20H80V20Z" />
    <path fill="#FFF" d="M60 20h20v20H60V20Z" />
    <path fill="#F0F0F0" d="M40 20h20v20H40V20Z" />
    <path fill="#FFF" d="M20 20h20v20H20V20Z" />
    <path fill="#F0F0F0" d="M0 20h20v20H0V20Z" />
    <path fill="#FFF" d="M880 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M860 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M840 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M820 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M800 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M780 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M760 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M740 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M720 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M700 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M680 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M660 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M640 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M620 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M600 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M580 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M560 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M540 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M520 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M500 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M480 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M460 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M440 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M420 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M400 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M380 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M360 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M340 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M320 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M300 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M280 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M260 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M240 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M220 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M200 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M180 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M160 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M140 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M120 0h20v20h-20V0Z" />
    <path fill="#F0F0F0" d="M100 0h20v20h-20V0Z" />
    <path fill="#FFF" d="M80 0h20v20H80V0Z" />
    <path fill="#F0F0F0" d="M60 0h20v20H60V0Z" />
    <path fill="#FFF" d="M40 0h20v20H40V0ZM0 0h20v20H0V0Z" />
    <path fill="#EFEFEF" d="M460 440h20v19c-4.88 1.952-7.81 2.103-12.813 1.625L460 460v-20Z" />
    <path
      fill="#FEFEFE"
      d="M300 140h20v20l-9.438.063-2.978.027-2.33.008-2.396.016C301 160 301 160 300 159a62.92 62.92 0 0 1-.098-4.254l.008-2.33.027-2.978L300 140ZM620 340h20v20c-4.115.03-4.115.03-8.313.063l-2.606.027-2.07.008-2.11.016C623 360 623 360 620 359v-19ZM580 340h20v20c-6.922.079-13.08-.135-20-1v-19Z"
    />
    <path fill="#FFF" d="M360 440h20v20c-6.904.087-13.057-.229-20-1v-19Z" />
    <path
      fill="#FEFEFE"
      d="m372.25 399.75 7.75.25v20h-20l-.25-7.75-.11-2.42c-.052-3.294.156-5.49 1.86-8.33 3.534-2.12 6.77-1.931 10.75-1.75ZM280 440h20v18c-7.5 1.875-12.458 2.171-20 2v-20ZM500 340h20v18c-7.5 1.875-12.458 2.171-20 2v-20Z"
    />
    <path fill="#FFF" d="M284 400h16v20h-20v-17h4v-3Z" />
    <path fill="#FEFEFE" d="M460 340h20v18c-7.5 1.875-12.458 2.171-20 2v-20Z" />
    <path fill="#FFF" d="M440 400h14v3h6v17h-20v-20Z" />
    <path
      fill="#FEFEFE"
      d="M582 300h18v20h-20c0-8 0-8 1-9 .234-1.849.413-3.705.563-5.563L582 300Z"
    />
    <path fill="#F0F0F0" d="M260 400h12v3h8v17h-20v-20Z" />
    <path fill="#EFEFEF" d="M399 499h2l1 3 11 1-1-3h8v20h-20l-1-21Z" />
    <path
      fill="#FFF"
      d="M420 500h2v3h12v-3h6v20h-20v-20ZM492 400h8v20h-20v-17h12v-3ZM400 400h6v3h12v-3h2v20h-20v-20Z"
    />
    <path
      fill="#B7B7B8"
      d="m605.75 458.875 3.547.055L612 459v1h-12v9l2-1c7.137-.576 7.137-.576 10.438 1.625C614 472 614 472 615 478h-15v2h-14c.458-7.556 1.888-11.5 7-17.25 4.155-3.635 7.25-3.985 12.75-3.875Z"
    />
    <path fill="#F0F0F0" d="M582 280h18v20h-18v-20Z" />
    <path fill="#FFF" d="M582 260h18v20h-18v-20Z" />
    <path fill="#F0F0F0" d="M582 240h18v20h-18v-20Z" />
    <path fill="#FFF" d="M582 220h18v20h-18v-20Z" />
    <path fill="#F0F0F0" d="M582 200h18v20h-18v-20Z" />
    <path fill="#FFF" d="M582 180h18v20h-18v-20Z" />
    <path fill="#F0F0F0" d="M582 160h18v20h-18v-20Z" />
    <path fill="#FFF" d="M582 140h18v20h-18v-20Z" />
    <path fill="#FEFEFE" d="M540 140h18v20h-18v-20Z" />
    <path fill="#F0F0F0" d="M582 120h18v20h-18v-20Z" />
    <path
      fill="#FEFEFE"
      d="m308 499 1 3 11 1v17h-20l-.375-8.25-.166-2.58c-.048-2.188.002-4.043.541-6.17 4.552-4 4.552-4 8-4ZM528 399l1 3 11 1v17h-20l-.375-8.25-.166-2.58c-.048-2.188.002-4.043.541-6.17 4.552-4 4.552-4 8-4Z"
    />
    <path
      fill="#FDFDFD"
      d="M260 120h12a56.54 56.54 0 0 1-7 4c.516 7.594 2.987 14.253 5.563 21.375.837 2.34 1.672 4.681 2.503 7.023l1.124 3.115C275 158 275 158 275 160h-15v-40Z"
    />
    <path
      fill="#EFEFEF"
      d="m525 497 1.758 1.277 2.367 1.66 2.32 1.653c2.963 1.82 2.963 1.82 8.555 2.41v16h-20v-17h5v-6ZM494 499l1 3 5 1v17h-20v-16l6.738-2.148C489.416 500.843 491.1 499 494 499Z"
    />
    <path
      fill="#ACACAD"
      d="M280 140h14c1.008 2.58 2.007 5.164 3 7.75l.867 2.21.82 2.15.762 1.967C300 156 300 156 300 160h-20v-20Z"
    />
    <path fill="#FEFEFE" d="M400 500v20h-20v-17l5.625.188c5.395.019 9.588-3.188 14.375-3.188Z" />
    <path fill="#B4B4B5" d="M400 120h20v17h-20v-17ZM360 120h20v17h-20v-17Z" />
    <path
      fill="#EFEFEF"
      d="M620 500v20h-20v-16l5-.313c4.928-.432 10.436-3.687 15-3.687ZM340 402l5 1c5.735.284 11.368.218 17-1l-1 2c-.232 2.714-.42 5.406-.563 8.125L360 420h-20v-18Z"
    />
    <path
      fill="#FEFEFE"
      d="M320 480h13c1.173 2.768 2.339 5.54 3.5 8.313l1.012 2.38.957 2.295.888 2.11C340 497 340 497 340 500h-20v-20Z"
    />
    <path fill="#B4B4B5" d="M460 60h20l1 13-21 7V60Z" />
    <path
      fill="#FEFEFE"
      d="M520 440h20v18l-6.543 2.05c-2.987 1.074-2.987 1.074-7.457 3.95v-21h-6v-3Z"
    />
    <path fill="#EFEFEF" d="M280 100h20l1 11-21 7v-18Z" />
    <path
      fill="#FDFDFD"
      d="M300 260h11a2317.5 2317.5 0 0 1 3 8.313l.867 2.38.82 2.295.762 2.11C317 277 317 277 317 280h-17v-20Z"
    />
    <path
      fill="#ACACAD"
      d="M283 180h17v20h-11a2317.5 2317.5 0 0 1-3-8.313l-.867-2.38-.82-2.295-.762-2.11C283 183 283 183 283 180Z"
    />
    <path
      fill="#B4B4B5"
      d="m382 83-1 1a226.242 226.242 0 0 0-.563 8.063L380 100h-20V90c18.77-8.615 18.77-8.615 22-7Z"
    />
    <path
      fill="#B6B6B7"
      d="M457 359c2.348.957 2.348.957 4 3 .346 3.099.052 6.093-.25 9.188-.066.844-.131 1.69-.2 2.56A430.573 430.573 0 0 1 460 380h-5v23h-1l-.076-3.013c-.094-3.677-.194-7.354-.296-11.031-.044-1.594-.085-3.188-.125-4.781-.058-2.287-.122-4.573-.187-6.859l-.05-2.171c.184-3.36.184-3.36-1.266-6.145-5.536-.483-5.536-.483-10.5 1.5L440 372v-7h-2v-5l1 4 2.813-2.5c4.657-3.346 9.64-3.52 15.187-2.5Z"
    />
    <path
      fill="#E7E7E7"
      d="M514 443h12v1h-11v59l-1-3h-8l-1 2c-.941-2.824-1.117-4.53-1.098-7.45l.01-2.568.026-2.67.013-2.705c.012-2.202.03-4.405.049-6.607h10v-37Z"
    />
    <path
      fill="#EFEFEF"
      d="M340 80h20l1 10a2709.017 2709.017 0 0 1-8.813 3l-2.525.867-2.432.82-2.237.762C343 96 343 96 340 96V80Z"
    />
    <path
      fill="#FDFDFD"
      d="M280 200h10a2317.5 2317.5 0 0 1 3 8.313l.867 2.38.82 2.295.762 2.11C296 217 296 217 296 220h-16v-20Z"
    />
    <path fill="#F0F0F0" d="M560 100h20v13h-20v-13Z" />
    <path
      fill="#ACACAD"
      d="M304 240h16v20h-10a2317.5 2317.5 0 0 1-3-8.313l-.867-2.38-.82-2.295-.762-2.11C304 243 304 243 304 240Z"
    />
    <path fill="#B5B5B6" d="M320 104v16h-20v-9c15.448-7 15.448-7 20-7Z" />
    <path fill="#F2F2F2" d="M353 137h205v3h-18v-2H360v2l-7 1v-4Z" />
    <path
      fill="#F6F6F6"
      d="M496 99c1.623 2.434 2.617 4.313 3.625 7l.79 2.063C501 110 501 110 501 113h-21v-13a597.08 597.08 0 0 1 7.875-.688l2.262-.22c2.168-.166 2.168-.166 5.863-.092Z"
    />
    <path fill="#FFF" d="M260 380h12v20h-12v-20Z" />
    <path fill="#F0F0F0" d="M260 360h12v20h-12v-20Z" />
    <path
      fill="#EFEFEF"
      d="M400 60h20l1 9a2709.017 2709.017 0 0 1-8.813 3l-2.525.867-2.432.82-2.237.762C403 75 403 75 400 75V60Z"
    />
    <path
      fill="#ACACAD"
      d="M545 480h11c.501 8.016.13 12.71-5 19-1 1-1 1-3.285 1.098l-2.778-.036-2.785-.027L540 500c-.37-3.88-.28-5.586 1.938-8.875 2.591-3.927 2.742-6.485 3.062-11.125ZM428 360h10v5h2c.027 1.75.046 3.5.063 5.25l.035 2.953C440 376 440 376 439 380h-11v-20Z"
    />
    <path fill="#B4B4B5" d="M422 460h11v20h-11v-20ZM406 360h11v20h-11v-20Z" />
    <path fill="#ACACAD" d="M329 140h11v20h-11v-20Z" />
    <path
      fill="#EDEDED"
      d="M355 368c3.405 2.8 6.756 5.818 7.266 10.375L362.25 381l.016 2.625C362 386 362 386 360 389v-9h-19c.95-5.698 1.297-7.073 5-11 3.139-1.57 5.539-1.352 9-1Z"
    />
    <path
      fill="#B5B5B6"
      d="M472 359c6.044-.322 10.807-.546 16 3 2.536 2.548 2.984 3.806 3.293 7.453l-.106 3.797-.082 3.828L491 380h-11c-.889-6.914-.955-13.097 0-20h-8v-1Z"
    />
    <path
      fill="#EFEFEF"
      d="M404 460h16v20h-9l-.078-2.668-.172-3.52-.14-3.48c-.865-4.728-3.303-7.025-6.61-10.332Z"
    />
    <path
      fill="#ACACAD"
      d="M560 360c.211 7.044.08 13.241-2 20h-11c-.494-6.329-.117-10.098 3.566-15.336 2.811-3.263 5.142-4.664 9.434-4.664Z"
    />
    <path fill="#EFEFEF" d="M523 100h17v13h-13c-4-9.625-4-9.625-4-13Z" />
    <path
      fill="#ADADAE"
      d="M400 460c7.309 1.218 7.309 1.218 10.098 4.836 1.975 4.739 1.238 10.137.902 15.164h-11v-20Z"
    />
    <path fill="#FFF" d="M560 440h20v20h-2v-17h-12v17h-6v-20Z" />
    <path
      fill="#B6B6B7"
      d="M633.516 390.605 636 391c-1.275 5.483-3.4 7.815-8 11-5.35 2.612-11.163 2.597-17 2-3.688-1.5-3.688-1.5-6-3v-1h15v-5c2.832-6.513 7.407-5.176 13.516-4.395Z"
    />
    <path fill="#FFF" d="M300 340h20v3h-12v17h-8v-20Z" />
    <path
      fill="#ADADAE"
      d="M480 243v17h-20v-4l1.652-.227c3.247-1.07 5.302-2.955 7.91-5.148l2.88-2.398c2.478-2.09 2.478-2.09 4.273-4.016C478 243 478 243 480 243Z"
    />
    <path
      fill="#F6F6F6"
      d="M440 100h20v13c-5.547 0-5.547 0-8.875-2.438-3.805-2.56-6.576-3.278-11.125-3.562v-7Z"
    />
    <path
      fill="#B5B5B6"
      d="M447 107v1h-7v12h-20v-7l1.758-.078c5.56-.404 8.679-1.526 13.242-4.922 3.802-1.52 7.967-1.067 12-1Z"
    />
    <path
      fill="#FDFDFD"
      d="M526 480h14c.098 10.84.098 10.84 0 14-1 1-1 1-4.25 1.375-3.75-.375-3.75-.375-6.625-2.688C525.49 488.091 526 486.3 526 480Z"
    />
    <path fill="#FEFEFE" d="M486 360h14v20h-8l-.297-2.852c-.987-9.342-.987-9.342-5.703-17.148Z" />
    <path fill="#B5B5B6" d="M308 343h11v17h-11v-17Z" />
    <path
      fill="#FDFDFD"
      d="M569.77 367.52c2.553.55 3.542 1.194 5.293 3.105C577 374 577 374 577 380h-17c-.369-8.477-.369-8.477 1.238-10.758 2.802-1.975 5.188-1.837 8.532-1.722Z"
    />
    <path fill="#FFF" d="M320 160h9v20h-9v-20Z" />
    <path
      fill="#B6B6B7"
      d="M380 480v20h18c-5.65 4.237-9.058 4.624-16 4-3.259-1.456-5.713-3.255-8-6-1.35-4.05-1.557-7.765-1-12 3.75-6 3.75-6 7-6Z"
    />
    <path fill="#B4B4B5" d="M566 444h11v16h-11v-16ZM445 444h11v16h-11v-16Z" />
    <path
      fill="#B5B5B6"
      d="M500 180h16c-1.143 5.715-2.854 8.113-7 12-3.33 2.024-5.113 3-9 3v-15Z"
    />
    <path fill="#EFEFEF" d="M374 380h6v20h-15l2.875-3.688c4.003-5.368 5.339-9.63 6.125-16.312Z" />
    <path
      fill="#FBFBFB"
      d="M598 485h22v5h-7l-.938 1.938C611 494 611 494 610 495c-4.395.507-6.334.496-9.938-2.188C598 490 598 490 598 485Z"
    />
    <path fill="#B5B5B6" d="M620 465c3.332 3.332 4.495 5.556 6 10v9h-26v-4h20v-15Z" />
    <path
      fill="#FDFDFD"
      d="M540 380h6l.297 1.688c.974 4.973 2.373 9.134 4.8 13.585C552 397 552 397 553 400h-13v-20Z"
    />
    <path
      fill="#ACACAD"
      d="M325 300h15v13c-8.26.607-8.26.607-11.438-2-1.91-3.669-2.738-6.95-3.562-11Z"
    />
    <path fill="#B5B5B6" d="M520 242c6.31 5.075 11.772 10.826 17 17v1h-17v-18Z" />
    <path fill="#FFF" d="M420 380h8v20h-8v-20Z" />
    <path
      fill="#ADADAE"
      d="m291.504 459.902 3.058.036 3.067.027L300 460v7l-2.875.75c-3.212.936-3.212.936-4.5 3.375L292 473c-3.47-.458-6.674-.891-10-2 .415-4.843 2.462-6.816 6-10 1-1 1-1 3.504-1.098ZM511.504 359.902l3.058.036 3.067.027L520 360v7l-2.875.75c-3.212.936-3.212.936-4.5 3.375L512 373c-3.47-.458-6.674-.891-10-2 .415-4.843 2.462-6.816 6-10 1-1 1-1 3.504-1.098Z"
    />
    <path
      fill="#EEE"
      d="m586 479 .078 1.906c.508 7.657 2.71 12.776 6.922 19.094h-13v-20c5-1 5-1 6-1Z"
    />
    <path
      fill="#FBFBFB"
      d="M577 397c.769 8.799.769 8.799-2 13.125-4.105 2.566-6.212 2.416-11 1.875l-3-2c-.688-3.625-.688-3.625-1-7l1.723-.043C567.279 402.614 572.859 397 577 397Z"
    />
    <path
      fill="#FDFDFD"
      d="M452 368c2 2 2 2 2.195 4.383L454 380h-14c-.48-7.2-.48-7.2 1.5-10.5 3.714-2.229 6.2-1.916 10.5-1.5Z"
    />
    <path
      fill="#EDEDED"
      d="m474.125 367.5 3.875.5c2.802 4.202 2.145 7.001 2 12h-14c0-7 0-7 1.5-9.938 2.651-2.187 3.345-2.425 6.625-2.562Z"
    />
    <path fill="#B5B6B7" d="M540 263a182.067 182.067 0 0 1 17 16v1h-17v-17Z" />
    <path
      fill="#B6B6B7"
      d="m341 360 2 1-2 2c-.307 2.9-.512 5.718-.625 8.625l-.117 2.43A859.923 859.923 0 0 0 340 380h-10v6h-1c-.746-7.793.502-13.52 5-20 2.217-2.3 4.425-4.081 7-6Z"
    />
    <path fill="#F5F5F5" d="m480 185 5 5c4.744 3.625 9.106 4.586 15 5v5h-20v-15Z" />
    <path
      fill="#FCFCFC"
      d="M306 483c.357 7.13.357 7.13-1 10.438-3.054 2.386-6.173 2.753-10 2.562-2-1.063-2-1.063-3-3-.5-3-.5-3 0-6 4.378-3.526 8.525-4.152 14-4Z"
    />
    <path
      fill="#FAFAFA"
      d="M492 483c.357 7.13.357 7.13-1 10.438-3.054 2.386-6.173 2.753-10 2.562-2-1.063-2-1.063-3-3-.5-3-.5-3 0-6 4.378-3.526 8.525-4.152 14-4Z"
    />
    <path
      fill="#EDEDED"
      d="M399 483c.357 7.13.357 7.13-1 10.438-3.054 2.386-6.173 2.753-10 2.562-2-1.063-2-1.063-3-3-.5-3-.5-3 0-6 4.378-3.526 8.525-4.152 14-4Z"
    />
    <path
      fill="#FCFCFC"
      d="M387 468a364.73 364.73 0 0 1 4.875-.125l2.742-.07C397 468 397 468 399 470c.125 2.625.125 2.625 0 5-5.901 2.665-12.493 4.42-19 4v-6h5l2-5ZM526 383c.357 7.13.357 7.13-1 10.438-3.054 2.386-6.173 2.753-10 2.562-2-1.063-2-1.063-3-3-.5-3-.5-3 0-6 4.378-3.526 8.525-4.152 14-4Z"
    />
    <path
      fill="#FDFDFD"
      d="M621 368c2.438 1.625 2.438 1.625 4 4l1 6h-17c0-6 0-6 1.5-8.375 3.505-2.279 6.43-2.444 10.5-1.625Z"
    />
    <path
      fill="#EEE"
      d="M460 480h12l-2.5 2.438c-2.85 3.407-3.05 6.093-2.809 10.437.377 2.595 1.107 4.796 2.309 7.125h-9v-20Z"
    />
    <path fill="#ADADAE" d="M498 225h2v15h-17c4.278-5.24 8.839-9.64 14-14l1-1Z" />
    <path fill="#B5B5B6" d="M272 343h12l-4 1v16h-8v-17Z" />
    <path fill="#F0F0F0" d="M560 313h20v7h-20v-7Z" />
    <path fill="#FFF" d="M540 313h20v7h-20v-7Z" />
    <path fill="#F0F0F0" d="M520 313h20v7h-20v-7Z" />
    <path fill="#FFF" d="M500 313h20v7h-20v-7Z" />
    <path fill="#F0F0F0" d="M480 313h20v7h-20v-7Z" />
    <path fill="#FFF" d="M460 313h20v7h-20v-7Z" />
    <path fill="#F0F0F0" d="M440 313h20v7h-20v-7Z" />
    <path fill="#FFF" d="M420 313h20v7h-20v-7Z" />
    <path fill="#F0F0F0" d="M400 313h20v7h-20v-7Z" />
    <path fill="#FFF" d="M380 313h20v7h-20v-7ZM340 313h20v7h-20v-7Z" />
    <path fill="#B4B4B5" d="M460 113h20v7h-20v-7ZM380 113h20v7h-20v-7Z" />
    <path
      fill="#FEFEFE"
      d="M354 220h6v20h-7c-.029-3.146-.047-6.292-.063-9.438l-.025-2.72-.01-2.588-.016-2.396C353 221 353 221 354 220ZM354 180h6v20h-7c-.029-3.146-.047-6.292-.063-9.438l-.025-2.72-.01-2.588-.016-2.396C353 181 353 181 354 180ZM354 140h6v20h-7c-.029-3.146-.047-6.292-.063-9.438l-.025-2.72-.01-2.588-.016-2.396C353 141 353 141 354 140Z"
    />
    <path
      fill="#B8B8B9"
      d="m486.75 458.875 2.402.027c1.95.024 3.899.06 5.848.098v1h-15l.125 4.25c.115 3.91-.253 5.006-2.125 8.75l-11-1c1.438-5.62 3.869-8.807 8.617-12.133 3.673-1.336 7.26-1.075 11.133-.992Z"
    />
    <path fill="#B5B5B6" d="M357 460h3v20h-10c1.73-7.009 3.84-13.503 7-20Z" />
    <path fill="#B2B2B2" d="M422 443h12v11h-12v-11ZM406 343h12v11h-12v-11Z" />
    <path
      fill="#E8E8E8"
      d="M608 384h29v1h-17l1 10c-4.31.423-6.33.496-9.875-2.125C609 390 609 390 608 384Z"
    />
    <path fill="#EEE" d="M625 360h15v20h-3l-.516-1.977c-2.253-8.127-4.738-12.626-11.484-18.023Z" />
    <path
      fill="#FDFDFD"
      d="M380 220h13c-1.75 4.376-3.698 7.628-6.5 11.313l-1.223 1.666c-1.04 1.381-2.153 2.707-3.277 4.021h-2v-17Z"
    />
    <path
      fill="#EFEFEF"
      d="M608.094 467.613C610 468 610 468 612.5 469.688 614 472 614 472 614 477h-16c0-5 0-5 1.5-7.313 3.049-2.057 4.977-2.27 8.594-2.074Z"
    />
    <path
      fill="#ADADAE"
      d="M548 406c4.276-.084 7.764.153 12 1v12c-4.024-.232-6.32-.392-9.375-3.125-1.888-3.34-2.327-6.073-2.625-9.875Z"
    />
    <path fill="#B7B7B8" d="M465 378h1v25l-1-3h-5v-20h5v-2Z" />
    <path
      fill="#EDEEEE"
      d="M260 120h12a56.54 56.54 0 0 1-7 4c.59 5.508 1.567 10.649 3 16h-8v-20Z"
    />
    <path fill="#FFF" d="M560 480h6v20h-6v-20Z" />
    <path fill="#F0F0F0" d="M560 460h6v20h-6v-20Z" />
    <path fill="#FFF" d="M400 360h6v20h-6v-20Z" />
    <path fill="#ACACAD" d="M580 400h8c.306 5.822-.034 9.784-3 15l-5 3v-18Z" />
    <path
      fill="#FDFDFD"
      d="M329 126v14h-9c-.285-3.379-.45-6.632 0-10 2.375-2.063 2.375-2.063 5-3 2-1 2-1 4-1Z"
    />
    <path
      fill="#EDEDED"
      d="m484.938 467.813 2.714-.043C490 468 490 468 492 470c.125 2.625.125 2.625 0 5-3.967 1.803-7.682 2.492-12 3-.194-1.478-.38-2.958-.563-4.438l-.316-2.496L479 469c1.666-1.666 3.66-1.171 5.938-1.188Z"
    />
    <path fill="#FFF" d="M440 480h5v20h-5v-20Z" />
    <path fill="#F0F0F0" d="M440 460h5v20h-5v-20Z" />
    <path fill="#EFEFEF" d="M557 480h3v20h-10l1.277-2.344c3.157-6 5.461-10.849 5.723-17.656Z" />
    <path
      fill="#F5F5F5"
      d="M510 160h10v20h-3l-.043-1.906c-.373-6.69-2.06-10.721-5.957-16.094l-1-2Z"
    />
    <path fill="#ACACAD" d="M280 380h3v23h-11v-3h8v-20Z" />
    <path
      fill="#AEAEAF"
      d="M500 42h2c1.004 2.624 2.003 5.249 3 7.875l.867 2.262C508 57.773 508 57.773 508 60h-8V42Z"
    />
    <path
      fill="#ADADAE"
      d="M420 207c3.94 1.97 5.178 3.115 7.75 6.5l1.86 2.406C431 218 431 218 431 220h-11v-13Z"
    />
    <path
      fill="#FCFCFC"
      d="M449 240h11v13h-2a106.595 106.595 0 0 1-4.625-5.375l-2.477-3.023C449 242 449 242 449 240Z"
    />
    <path
      fill="#AEAEAF"
      d="M300 163h2c.842 2.08 1.673 4.164 2.5 6.25l1.406 3.516C307 176 307 176 307 180h-7v-17Z"
    />
    <path fill="#F0F0F0" d="M880 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M860 540h20v4h-20v-4Z" />
    <path fill="#F0F0F0" d="M840 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M820 540h20v4h-20v-4Z" />
    <path fill="#F0F0F0" d="M800 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M780 540h20v4h-20v-4Z" />
    <path fill="#F0F0F0" d="M760 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M740 540h20v4h-20v-4Z" />
    <path fill="#F0F0F0" d="M720 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M700 540h20v4h-20v-4Z" />
    <path fill="#F0F0F0" d="M680 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M660 540h20v4h-20v-4Z" />
    <path fill="#F0F0F0" d="M640 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M620 540h20v4h-20v-4Z" />
    <path fill="#F0F0F0" d="M600 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M580 540h20v4h-20v-4Z" />
    <path fill="#F0F0F0" d="M560 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M540 540h20v4h-20v-4Z" />
    <path fill="#F0F0F0" d="M520 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M500 540h20v4h-20v-4Z" />
    <path fill="#F0F0F0" d="M480 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M460 540h20v4h-20v-4Z" />
    <path fill="#F0F0F0" d="M440 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M420 540h20v4h-20v-4Z" />
    <path fill="#F0F0F0" d="M400 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M380 540h20v4h-20v-4Z" />
    <path fill="#F0F0F0" d="M360 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M340 540h20v4h-20v-4Z" />
    <path fill="#F0F0F0" d="M320 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M300 540h20v4h-20v-4Z" />
    <path fill="#F0F0F0" d="M280 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M260 540h20v4h-20v-4Z" />
    <path fill="#F0F0F0" d="M240 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M220 540h20v4h-20v-4Z" />
    <path fill="#F0F0F0" d="M200 540h20v4h-20v-4Z" />
    <path fill="#FFF" d="M180 540h20v4h-20v-4Z" />
    <path
      fill="#F0F0F0"
      d="M160 540h20v4h-20v-4ZM120 540h20v4h-20v-4ZM80 540h20v4H80v-4ZM40 540h20v4H40v-4ZM0 540h20v4H0v-4Z"
    />
    <path fill="#ACACAD" d="M515 444h5v16h-5v-16Z" />
    <path
      fill="#FDFDFD"
      d="M480 40h20c-3.675 1.838-7.26 3.245-11.125 4.625l-3.758 1.352C482 47 482 47 480 47v-7Z"
    />
    <path fill="#B5B5B6" d="M636 375h1v9h-17v-4h16v-5Z" />
    <path
      fill="#F5F5F5"
      d="M322 220h7v19c-1.665-2.497-2.447-4.024-3.29-6.793l-.663-2.158-.672-2.237-.695-2.271A1492.68 1492.68 0 0 1 322 220Z"
    />
    <path
      fill="#B5B5B6"
      d="M333 480h7v17c-1.979-2.968-3.259-5.774-4.625-9.063l-1.352-3.222C333 482 333 482 333 480Z"
    />
    <path
      fill="#FCFCFC"
      d="M284 367h2c1.508 2.082 1.508 2.082 3.125 4.813l1.633 2.707C292 377 292 377 292 380h-8v-13Z"
    />
    <path
      fill="#B5B5B6"
      d="M440 80h18c-3.398 2.265-6.84 3.389-10.688 4.625l-2.126.695c-1.728.564-3.457 1.123-5.186 1.68v-7Z"
    />
    <path
      fill="#EDEDED"
      d="M303.563 482.938 306 483c.365 7.304.365 7.304-1.313 10.5C303 495 303 495 300 495a920.276 920.276 0 0 1-.063-5.438l-.035-3.058c.133-3.413.24-3.483 3.66-3.567ZM523.563 382.938 526 383c.365 7.304.365 7.304-1.313 10.5C523 395 523 395 520 395a920.276 920.276 0 0 1-.063-5.438l-.035-3.058c.133-3.413.24-3.483 3.66-3.567Z"
    />
    <path
      fill="#FDFDFD"
      d="M312 460h8v20h-2l-.043-2.598c-.31-7.443-.906-11.832-5.957-17.402ZM532 360h8v20h-2l-.043-2.598c-.31-7.443-.906-11.832-5.957-17.402Z"
    />
    <path fill="#B6B6B7" d="M500 463c4 4 4 4 4.39 7.234l-.14 3.516-.11 3.547L504 480h-4v-17Z" />
    <path
      fill="#ECECEC"
      d="M359 485h1v15h-7c.81-2.314 1.622-4.626 2.438-6.938l.697-1.998c1.752-4.95 1.752-4.95 2.865-6.064Z"
    />
    <path fill="#F0F0F0" d="M457 460h3v20h-3v-20Z" />
    <path fill="#E5E5E5" d="M620 368c4.714 2.357 4.714 2.357 6 6v4h-17v-1h11v-9Z" />
    <path fill="#FCFCFC" d="M400 200h8c-1.654 3.583-3.68 6.81-6 10h-2v-10Z" />
    <path
      fill="#B7B7B8"
      d="M460 55v5h-15c2.624-1.75 4.557-2.654 7.5-3.625.773-.26 1.547-.52 2.344-.79C457 55 457 55 460 55Z"
    />
    <path
      fill="#FCFCFC"
      d="M300 468c4.875.875 4.875.875 6 2 .125 2.5.125 2.5 0 5-1 1-1 1-3.563 1.063L300 476v-8ZM520 368c4.875.875 4.875.875 6 2 .125 2.5.125 2.5 0 5-1 1-1 1-3.563 1.063L520 376v-8Z"
    />
    <path fill="#FAFAFA" d="m540 470 4 2c.839 2.678.818 5.174 1 8h-5v-10Z" />
    <path fill="#ADADAE" d="M440 231c3.739 2.657 5.65 4.581 7 9h-7v-9Z" />
    <path fill="#ACACAD" d="M306 400h13v3h-12l-1-3Z" />
    <path fill="#FCFCFC" d="M433 220h7v8c-3.356-1.389-5.073-2.917-7-6v-2Z" />
    <path fill="#ADADAE" d="M294 380h6v10c-2.637-2.637-4.255-4.76-6-8v-2Z" />
    <path
      fill="#F5F5F5"
      d="M315 200h5v13c-1.904-2.856-2.695-4.931-3.625-8.188l-.79-2.73L315 200Z"
    />
    <path
      fill="#F1F1F1"
      d="M380 108v5h-13c2.666-1.777 4.627-2.658 7.625-3.625.797-.26 1.593-.52 2.414-.79C379 108 379 108 380 108Z"
    />
    <path fill="#ADADAE" d="M401 500h11l1 3h-11l-1-3Z" />
    <path fill="#B4B4B5" d="m318 499 2 4h-11l-1-3 10-1ZM538 399l2 4h-11l-1-3 10-1Z" />
    <path fill="#ACACAD" d="M566 500h11v3h-11v-3ZM445 500h11v3h-11v-3Z" />
    <path fill="#B4B4B5" d="M422 500h11v3h-11v-3ZM341 500h12l-1 3h-10l-1-3ZM480 400h11v3h-11v-3Z" />
    <path fill="#ACACAD" d="M428 400h11v3h-11v-3Z" />
    <path fill="#B4B4B5" d="M406 400h11v3h-11v-3Z" />
    <path
      fill="#BABABB"
      d="m402 76-2 4h-12c2.626-1.751 4.618-2.693 7.563-3.688l2.378-.824C400 75 400 75 402 76Z"
    />
    <path fill="#B7B7B8" d="M470 500h10v4c-6.625-.625-6.625-.625-10-4Z" />
    <path fill="#EDEDED" d="M516 80h4v12c-1.903-2.855-2.462-4.42-3.125-7.688l-.508-2.449L516 80Z" />
    <path fill="#AEAEAF" d="M300 372h2c2.042 2.905 3 4.401 3 8h-5v-8Z" />
    <path
      fill="#ACADAE"
      d="M276 160h4v11c-2.313-2.313-2.496-3.479-3.125-6.625l-.508-2.477L276 160Z"
    />
    <path fill="#ACACAD" d="M380 464v8l-5-1c.313-2.375.313-2.375 1-5 3-2 3-2 4-2Z" />
    <path
      fill="#FBFBFB"
      d="M600 360h7a858.147 858.147 0 0 1-2.938 3.5l-1.652 1.969L601 367h-1v-7Z"
    />
    <path fill="#FCFCFC" d="M295 360h5v8c-2.5-2.313-2.5-2.313-5-5v-3Z" />
    <path
      fill="#FBFBFB"
      d="m320 290 2 1c.633 2.066.633 2.066 1.125 4.563l.508 2.503L324 300h-4v-10Z"
    />
    <path fill="#B9B9BA" d="M540 500h9c-4.5 4-4.5 4-9 4v-4Z" />
    <path fill="#ADADAE" d="M620 491h5c-1.875 4.75-1.875 4.75-3 7h-2v-7Z" />
    <path fill="#EAEAEA" d="M344 480h5c-.586 6.152-.586 6.152-1 8l-2 1-2-9Z" />
    <path fill="#ACACAD" d="M620 480h6v4h-6v-4Z" />
    <path fill="#AEAEAF" d="M399 213h1v7h-5c1.074-2.915 1.778-4.778 4-7Z" />
    <path fill="#B6B7B7" d="M500 156c6.75 1.75 6.75 1.75 9 4h-9v-4Z" />
    <path
      fill="#ADADAE"
      d="M300 477v3h-11c4.01-2.673 6.172-3 11-3ZM520 377v3h-11c4.01-2.673 6.172-3 11-3Z"
    />
    <path fill="#ACACAD" d="M620 400h9l-1 2c-2.649.594-5.292.742-8 1v-3Z" />
    <path fill="#FBFBFB" d="M300 393c2.526 2.363 3.888 3.665 5 7h-5v-7Z" />
    <path fill="#BCBCBC" d="M340 470c2.296 3.445 2.54 5.938 3 10h-3v-10Z" />
    <path fill="#ADADAE" d="M599 372h1v8h-3c.875-6.875.875-6.875 2-8Z" />
    <path fill="#EDEDED" d="M320 100h9c-3.188 2.125-5.265 2.502-9 3v-3Z" />
    <path fill="#ACACAD" d="M494 500h6v3h-5l-1-3Z" />
    <path fill="#AEAEAF" d="M297 220h3v8c-2.565-2.565-2.54-4.477-3-8Z" />
  </svg>
)
export default SvgNotAvailableImage
